;(function() {
  'use strict'

  Controller.$inject = ["$q", "$scope", "$rootScope", "$timeout", "$interval", "$document", "$window", "$sce", "colors", "glUtils", "glDialog", "StateFactory", "ReportLink", "Question", "View", "Dashboard", "DashboardView", "ResponseFilter", "LocationSet", "subscriberService", "clipboardService", "glToast", "configService", "userService", "channelService", "datapackService", "profileService", "themeService", "surveyExplorerExitService", "surveyReport", "reportQuestionExporter", "reportPPTXExporter", "surveyExplorerXLSXService", "surveyExplorerPPTXService", "surveyExplorerSlotsService", "relocateDialogService", "helpService"];
  angular.module('app.core').component('surveyExplorer', {
    controller: Controller,
    templateUrl: 'survey-explorer.html',
    bindings: {
      survey: '<',
      dashboard: '<',
      options: '<',
    },
  })

  /* @ngInject */
  function Controller(
    $q,
    $scope,
    $rootScope,
    $timeout,
    $interval,
    $document,
    $window,
    $sce,
    colors,
    glUtils,
    glDialog,
    StateFactory,
    ReportLink,
    Question,
    View,
    Dashboard,
    DashboardView,
    ResponseFilter,
    LocationSet,
    subscriberService,
    clipboardService,
    glToast,
    configService,
    userService,
    channelService,
    datapackService,
    profileService,
    themeService,
    surveyExplorerExitService,
    surveyReport,
    reportQuestionExporter,
    reportPPTXExporter,
    surveyExplorerXLSXService,
    surveyExplorerPPTXService,
    surveyExplorerSlotsService,
    relocateDialogService,
    helpService
  ) {
    var ctrl = this
    var ChartTypes = DashboardView.ChartTypes
    var CHART_QUESTION_TYPES = [
      Question.Types.CHOICE,
      Question.Types.RANK,
      Question.Types.SCALE,
      Question.Types.NPS,
      Question.Types.MOOD,
      Question.Types.RATING,
      Question.Types.NUMERIC,
      Question.Types.MATRIX,
      Question.Types.CONSTANT_SUM,
      Question.Types.SCORE,
      Question.Types.HIDDEN_VARIABLES,
    ]
    var ALL_FILTER_NAME = 'All'
    var ALL_FILTER_KINDS = ['COMPLETE', 'EXIT', 'OVERQUOTA', 'QUALITYEXIT']
    var OLD_ALL_FILTER_KINDS = ['COMPLETE', 'EXIT', 'OVERQUOTA']

    var questionsById = {}
    var sectionsById = {}
    var beaconHiddenForMobile = false
    var handleViewportResize = _.debounce(() => {
      $scope.$evalAsync(() => {
        toggleBeaconForViewport()
        evaluateMobileTitleOverflow()
      })
    }, 200)

    ctrl.mobileTitleExpanded = false

    ctrl.itemClassPrefix = 'dashboard-tab-item-'

    ctrl.exporters = [
      { label: 'Workbook (xlsx)', type: 'workbook', public: true },
      { label: 'PowerPoint (pptx)', type: 'pptx', public: true },
      { label: 'All Responses (csv)', type: 'qcsv' },
      { label: 'All Responses (xlsx)', type: 'qxlsx' },
      { label: 'All Responses (spss-xlsx)', type: 'qspss' },
      // { label: 'Excel Workbook (xlsx)', type: 'xlsx' },
      // { label: 'PowerPoint (pptx)', type: 'pptx' },
    ]
    ctrl.exportQuestionsMode = [
      { value: 'ALL_INCLUDING_HIDDEN', label: 'All questions (incl. hidden)' },
      { value: 'EDITOR_VISIBLE', label: 'Visible questions in Editor' },
      { value: 'DASHBOARD_VISIBLE', label: 'Visible questions in Dashboard' },
    ]
    ctrl.expandedExporter = null

    ctrl.chartTypeOptions = [
      {
        label: 'Stacked Bars',
        icon: 'stacked-chart',
        value: ChartTypes.STACKED_BAR,
      },
      {
        label: 'Grouped Bars',
        icon: 'bar-chart',
        value: ChartTypes.GROUPED_BAR,
      },
      {
        label: 'Line',
        icon: 'chart',
        value: ChartTypes.LINE,
      },
      {
        label: 'Stacked Area',
        icon: 'area-chart',
        value: ChartTypes.STACKED_AREA,
      },
      {
        label: 'Spider',
        icon: 'radar',
        value: ChartTypes.SPIDER,
      },
      {
        label: 'Pie',
        icon: 'pie-chart',
        value: ChartTypes.PIE,
      },
    ]

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.isMobile = isMobile
    ctrl.evaluateMobileTitleOverflow = _.debounce(
      evaluateMobileTitleOverflow,
      200
    )
    ctrl.isSidebarOverlay = isSidebarOverlay
    ctrl.isSidebarOpen = isSidebarOpen
    ctrl.toggleSidebar = toggleSidebar
    ctrl.toggleSwitcher = toggleSwitcher
    ctrl.switchDashboard = switchDashboard
    ctrl.duplicateDashboard = duplicateDashboard
    ctrl.destroyDashboard = destroyDashboard
    ctrl.addDashboard = addDashboard
    ctrl.showExcludedViewsDialog = showExcludedViewsDialog
    ctrl.setTab = setTab
    ctrl.setView = setView
    ctrl.isSectionView = isSectionView
    ctrl.ensureSelectedViewVisible = ensureSelectedViewVisible
    ctrl.getViewIndex = getViewIndex
    ctrl.cycleView = cycleView
    ctrl.isSlot = isSlot
    ctrl.getSlotOptions = getSlotOptions
    ctrl.getSlotValue = getSlotValue
    ctrl.getSlotLabel = getSlotLabel
    ctrl.setSlotValue = setSlotValue
    ctrl.toggleShownBase = toggleShownBase
    ctrl.isSlotConfig = isSlotConfig
    ctrl.editSlotConfig = editSlotConfig
    ctrl.getTargetTypeLabel = getTargetTypeLabel
    ctrl.getTargetLabel = getTargetLabel
    ctrl.getAllPrefilters = getAllPrefilters
    ctrl.isGlobalPrefilter = isGlobalPrefilter
    ctrl.isLocalPrefilter = isLocalPrefilter
    ctrl.createFilter = createFilter
    ctrl.importFilters = importFilters
    ctrl.editFilters = editFilters
    ctrl.onRemoveFilter = onRemoveFilter
    ctrl.removeFilterByContext = removeFilterByContext
    ctrl.addPrefilters = addPrefilters
    ctrl.addViewFilters = addViewFilters
    ctrl.manageViewFilters = manageViewFilters
    ctrl.hasChart = hasChart
    ctrl.hasTable = hasTable
    ctrl.hasList = hasList
    ctrl.hasCloud = hasCloud
    ctrl.hasImages = hasImages
    ctrl.hasMap = hasMap
    ctrl.hasChoiceCapture = hasChoiceCapture
    ctrl.queryList = _.debounce(queryList, 200, {
      trailing: true,
    })
    ctrl.queryChoiceCapture = _.debounce(queryChoiceCapture, 200, {
      trailing: true,
    })
    ctrl.editTheme = editTheme
    ctrl.exportAs = exportAs

    ctrl.isResponsesExporter = isResponsesExporter
    ctrl.isSimpleExporter = isSimpleExporter
    ctrl.toggleExporterSubmenu = toggleExporterSubmenu
    ctrl.onExportMenuClose = onExportMenuClose

    ctrl.setChartType = setChartType
    ctrl.isChartRotatable = isChartRotatable
    ctrl.toggleChartRotate = toggleChartRotate
    ctrl.toggleChartAbsolute = toggleChartAbsolute
    ctrl.toggleTableAbsolute = toggleTableAbsolute
    ctrl.copyTableToClipboard = copyTableToClipboard
    ctrl.editSettings = editSettings
    ctrl.editWeightScheme = editWeightScheme
    ctrl.switchToV1 = switchToV1
    ctrl.copyShareLink = copyShareLink
    ctrl.save = save
    ctrl.onCanvasInit = onCanvasInit
    ctrl.exportDashboardWorkbook = exportDashboardWorkbook
    ctrl.getSelectedItems = getSelectedItems
    ctrl.getCurrentAndSelectedViews = getCurrentAndSelectedViews
    ctrl.getSelectedInfo = getSelectedInfo
    ctrl.toggleSelectItem = toggleSelectItem
    ctrl.canMove = canMove
    ctrl.moveItems = moveItems
    ctrl.canDuplicateItems = canDuplicateItems
    ctrl.duplicateItems = duplicateItems
    ctrl.canEditItems = canEditItems
    ctrl.editItems = editItems
    ctrl.isTogglePrivate = isTogglePrivate
    ctrl.togglePrivateItems = togglePrivateItems
    ctrl.showRelocateDialog = showRelocateDialog
    ctrl.removeItems = removeItems
    ctrl.clearSelection = clearSelection

    function onInit() {
      window.ctrl = ctrl
      ctrl.showSidebar = !isMobile()
      ctrl.subscriber = subscriberService.getSubscriber()
      ctrl.isSSR = userService.isSSR()
      ctrl.options = ctrl.options || {}
      ctrl.isShared = ctrl.options.isShared || false
      $document.bind('keydown', onKeyDown)
      $window.addEventListener('resize', handleViewportResize)
      handleViewportResize()
      setTab('views')
      ctrl.state = new StateFactory([
        'building',
        'loading',
        'ready',
        'noResponses',
        'error',
      ])
      for (var view of ctrl.survey.views) {
        if (view.type === View.Types.QUESTION) {
          var question = view.value
          questionsById[question.id] = question
        }
        if (view.type === View.Types.SECTION) {
          var section = view.value
          sectionsById[section.id] = section
        }
      }
      // if a dashboard was supplied, we're probs looking at a shared dashboard
      if (ctrl.dashboard) {
        console.log('viewing shared dashboard')
        ctrl.state.loading()
        ctrl.isShared = true
        ctrl.dashboards = [ctrl.dashboard]
        var dashboard = ctrl.dashboard
        ctrl.dashboard = null // allow it to be selected
        return loadProfile()
          .then(function() {
            return datapackService
              .getDatapack(ctrl.survey)
              .then(function(datapack) {
                ctrl.datapack = datapack
                return datapackService
                  .getCSV(ctrl.survey.id)
                  .then(function(csv) {
                    ctrl.csv = csv
                    setupDatapack()
                    selectDashboard(dashboard)
                    return loadChannels().then(function() {
                      ctrl.state.ready()
                    })
                  })
              })
          })
          .catch(function(err) {
            console.error(err)
            ctrl.state.error()
          })
      } else {
        console.log('viewing all dashboards')
        ctrl.state.loading()
        loadProfile()
          .then(function() {
            ensureDatapack().then(function() {
              return datapackService
                .getDatapack(ctrl.survey)
                .then(function(datapack) {
                  ctrl.datapack = datapack
                  return datapackService
                    .getCSV(ctrl.survey.id)
                    .then(function(csv) {
                      ctrl.csv = csv
                      setupDatapack()
                      return datapackService
                        .listDashboards(ctrl.survey.id)
                        .then(function(dashboards) {
                          ctrl.dashboards = dashboards
                          return initDashboard().then(function() {
                            return loadChannels().then(function() {
                              ctrl.state.ready()
                              watchUnsaved(true)
                            })
                          })
                        })
                    })
                })
                .catch(function(err) {
                  console.error(err)
                  ctrl.state.error()
                })
            })
          })
          .catch(function(err) {
            console.error(err)
            ctrl.state.error()
          })
      }
    }

    function ensureDatapack() {
      if (ctrl.survey.hasDatapack) {
        return $q.resolve()
      }
      ctrl.state.building()
      return datapackService.createDatapack(ctrl.survey.id)
    }

    function initDashboard() {
      if (ctrl.dashboards.length) {
        return datapackService
          .getDashboard(ctrl.survey, ctrl.dashboards[0].id)
          .then(function(dashboard) {
            selectDashboard(dashboard)
          })
      }
      addDashboard('New Dashboard')
      return $q.resolve()
    }

    function loadProfile() {
      return profileService.get(ctrl.survey.ownerId).then(function(profile) {
        ctrl.profile = profile
      })
    }

    function loadChannels() {
      if (ctrl.isShared) {
        ctrl.channels = []
        console.error('TODO: need to get channels publicly?')
        return $q.resolve()
      }

      return channelService
        .getBySurvey(ctrl.survey.id, null, {
          // token: survey.options.shareToken,
        })
        .then(function(channels) {
          ctrl.channels = channels
        })
    }

    function isMobile() {
      return document.body.offsetWidth <= 1024
    }

    function toggleBeaconForViewport() {
      if (!helpService.isSupported()) return
      var mobile = isMobile()
      if (mobile && !beaconHiddenForMobile) {
        beaconHiddenForMobile = true
        helpService.hide()
      }
      if (!mobile && beaconHiddenForMobile) {
        beaconHiddenForMobile = false
        helpService.show()
      }
    }

    function evaluateMobileTitleOverflow() {
      if (!isMobile() || ctrl.mobileTitleExpanded) return
      var titleEl = document.getElementsByClassName(
        'survey-explorer__mobile-head-title'
      )[0]
      if (!titleEl) return
      ctrl.mobileTitleOverflow = titleEl.scrollWidth > titleEl.clientWidth
    }

    function shouldHandleViewCycle(e) {
      if (
        !ctrl.state.isReady() ||
        !ctrl.dashboard ||
        !ctrl.dashboard.views.length
      ) {
        return false
      }
      if (glDialog.isActive()) {
        return false
      }

      var target = e.target || $document[0].activeElement
      if (!target) return true

      var tag = (target.tagName || '').toLowerCase()
      if (
        target.isContentEditable ||
        tag === 'input' ||
        tag === 'textarea' ||
        tag === 'select' ||
        target.closest('[contenteditable]')
      ) {
        return false
      }
      if (target.closest('.field-text, .field-select, .g-menu-item')) {
        return false
      }
      if ($document[0].body.querySelector('g-menu-mount')) {
        return false
      }
      return true
    }

    function onKeyDown(e) {
      if (!shouldHandleViewCycle(e)) return

      if (e.code === 'ArrowDown' || e.code === 'ArrowRight') {
        e.preventDefault()
        $scope.$applyAsync(function() {
          cycleView(1)
        })
      } else if (e.code === 'ArrowUp' || e.code === 'ArrowLeft') {
        e.preventDefault()
        $scope.$applyAsync(function() {
          cycleView(-1)
        })
      }
    }

    function isSidebarOverlay() {
      return isMobile() ? ctrl.showSidebar : false
    }

    function isSidebarOpen() {
      return !isMobile()
    }

    function toggleSidebar() {
      ctrl.showSidebar = !ctrl.showSidebar
    }

    function toggleSwitcher(e) {
      if (e.defaultPrevented) return
      e.isSwitcher = true
      ctrl.switcherOpen = !ctrl.switcherOpen
      if (ctrl.switcherOpen) {
        document.addEventListener('click', onSwitcherDocumentClick)
      } else {
        document.removeEventListener('click', onSwitcherDocumentClick)
      }
    }

    function onSwitcherDocumentClick(e) {
      if (e.isSwitcher) return
      $scope.$applyAsync(function() {
        ctrl.switcherOpen = false
      })
    }

    function switchDashboard(id) {
      if (ctrl.dashboard.id === id) return
      if (!surveyExplorerExitService.check()) return
      if (ctrl.dashboard.isNew) {
        // discard new and unsaved
        ctrl.dashboards = ctrl.dashboards.filter(function(d) {
          return d.id !== ctrl.dashboard.id
        })
      }
      var listIdx = ctrl.dashboards.findIndex(function(d) {
        return d.id === id
      })
      var listItem = ctrl.dashboards[listIdx]
      // if we already have the full dashboard in our list use that so switching is instant
      if (listItem.views) {
        selectDashboard(listItem)
      }
      // otherwise we need to fetch it
      if (!listItem.views) {
        datapackService.getDashboard(ctrl.survey, id).then(function(dashboard) {
          // replace the list item stub
          ctrl.dashboards[listIdx] = dashboard
          // select it
          selectDashboard(dashboard)
        })
      }
    }

    function duplicateDashboard() {
      var dashboard = ctrl.dashboard.clone().refresh()
      if (!dashboard.name.endsWith(' (Copy)')) {
        dashboard.name = dashboard.name + ' (Copy)'
      }
      dashboard.commit()
      ctrl.dashboards.push(dashboard)
      selectDashboard(dashboard)
    }

    function destroyDashboard() {
      var dashboard = ctrl.dashboard
      var idx = ctrl.dashboards.findIndex(function(d) {
        return d.id === dashboard.id
      })
      var nextDashboard = ctrl.dashboards[idx + 1]
      if (!nextDashboard) nextDashboard = ctrl.dashboards[idx - 1]
      ctrl.dashboards = ctrl.dashboards.filter(function(d) {
        return d.id !== dashboard.id
      })
      if (!dashboard.isNew) {
        datapackService.deleteDashboard(dashboard)
      }
      if (nextDashboard) {
        switchDashboard(nextDashboard.id)
      } else {
        addDashboard('New Dashboard')
      }
    }

    function addDashboard(name) {
      if (!surveyExplorerExitService.check()) return
      // create in-memory dashboard
      var dashboard = new Dashboard(ctrl.survey)
      dashboard.name = name

      // create an "All" filter (completes, exits, overquotas)
      var filter = new ResponseFilter(ctrl.survey)
      filter.name = ALL_FILTER_NAME
      var group = filter.addGroup()
      var rule = group.addRule()
      rule.setType(rule.Types.KIND)
      rule.kinds = ALL_FILTER_KINDS.slice()
      dashboard.filters.push(filter)

      // add views for each question and section
      var views = []
      _.each(ctrl.survey.views, function(view) {
        if (view.type === View.Types.QUESTION) {
          if (view.value.isHidden) return
          var view = new DashboardView().fromQuestion(view.value)
          views.push(view)
        }
        if (view.type === View.Types.SECTION) {
          if (view.value.isHidden) return
          views.push(new DashboardView().fromSection(view.value))
        }
      })
      dashboard.views = views

      // add the "All" filter to each view's local filter list
      dashboard.views.forEach(function(view) {
        view.configs.filters.items.push(filter.id)
      })

      // console.log('survey', ctrl.survey)
      // console.log('datapack', ctrl.datapack)
      // console.log('csv', ctrl.csv)
      // console.log('dashboard', ctrl.dashboard)

      dashboard.commit()
      ctrl.dashboards.push(dashboard)

      selectDashboard(dashboard)
    }

    function selectDashboard(dashboard) {
      if (ctrl.dashboard === dashboard) return

      var prevActiveView = ctrl.view && {
        id: ctrl.view.id,
        questionId: ctrl.view.questionId,
        sectionId: ctrl.view.sectionId,
      }

      if (ctrl.dashboard) {
        if (ctrl.dashboard.isNew) {
          ctrl.dashboards = ctrl.dashboards.filter(function(d) {
            return d.id !== ctrl.dashboard.id
          })
        } else {
          ctrl.dashboard.revert()
          syncDashboard(ctrl.dashboard)
        }
      }

      ctrl.dashboard = dashboard
      ctrl.dashboard.readOnly = dashboard.sharedReadOnly && ctrl.isShared

      // map filters by id for easy lookup
      ctrl.filtersById = {}
      for (const filter of ctrl.dashboard.filters) {
        ctrl.filtersById[filter.id] = filter
      }

      // initialize filter matchers
      for (var filter of dashboard.filters) {
        filter.match = filter.toDatapackMatcher(ctrl.datapack)
      }

      var view
      if (prevActiveView) {
        view = ctrl.dashboard.views.find(function(v) {
          return v.id === prevActiveView.id
        })
      }
      if (!view && prevActiveView && prevActiveView.questionId) {
        view = ctrl.dashboard.views.find(function(v) {
          return v.questionId === prevActiveView.questionId
        })
      }
      if (!view && prevActiveView && prevActiveView.sectionId) {
        view = ctrl.dashboard.views.find(function(v) {
          return v.sectionId === prevActiveView.sectionId
        })
      }
      if (!view) {
        view = ctrl.dashboard.views.find(function(view) {
          return ctrl.isShared ? !view.private : true
        })
      }

      // filter out private views and filters if shared dashboard
      if (ctrl.isShared) {
        ctrl.dashboard.views = _.filter(ctrl.dashboard.views, {
          private: false,
        })
        ctrl.dashboard.filters = _.filter(ctrl.dashboard.filters, {
          private: false,
        })
      }

      ctrl.logoImageUrl =
        ctrl.isShared &&
        !ctrl.dashboard.logoImageHidden &&
        (ctrl.dashboard.logoImageUrl || ctrl.profile.logoImageUrl)

      applyWeightScheme()

      setView(null, view)

      updateExcludedViews()
      updateRestricted()

      watchUnsaved(true)
    }

    function applyWeightScheme() {
      ctrl.dashboard.weightScheme.apply(
        ctrl.csv,
        ctrl.datapack,
        ctrl.filtersById
      )
    }

    function syncDashboard(dashboard, oldId) {
      var listDashboard = ctrl.dashboards.find(function(d) {
        return d.id === oldId || d.id === dashboard.id
      })
      if (listDashboard) {
        listDashboard.id = dashboard.id
        listDashboard.name = dashboard.name
      }
    }

    function setupDatapack() {
      // sometimes csv has an extra empty row?
      if (ctrl.csv[ctrl.csv.length - 1][0] === '') {
        ctrl.csv.pop()
        console.log('removed empty row')
      }

      // remove deleted completely (later we may support this)
      var deletedIdx = ctrl.datapack.mappings.columns.isDeleted
      ctrl.csv = ctrl.csv.filter(function(row) {
        return row[deletedIdx] !== '1'
      })

      // TODO: remove this after BE uses 0 column array indices
      // for (const key in ctrl.datapack.mappings.columns) {
      //   ctrl.datapack.mappings.columns[key]--
      // }

      // repopulate non-column mapping values so its easier to work with
      for (const type in ctrl.datapack.mappings) {
        if (type === 'columns') continue
        var idx = ctrl.datapack.mappings.columns[type]
        for (const row of ctrl.csv) {
          var key = row[idx]
          var value = ctrl.datapack.mappings[type][key]
          row[idx] = value
        }
      }

      // use moment for createdAt dates
      var createdAtIdx = ctrl.datapack.mappings.columns.createdAt
      for (const row of ctrl.csv) {
        var value = parseInt(row[createdAtIdx])
        var date = moment(value)
        row[createdAtIdx] = date
      }

      // create our "completesOnly" filter
      {
        var filter = new ResponseFilter(ctrl.survey)
        filter.name = 'Completes'
        var group = filter.addGroup()
        var rule = group.addRule()
        rule.setType(rule.Types.KIND)
        rule.kinds.push('COMPLETE')
        filter.match = filter.toDatapackMatcher(ctrl.datapack)
        ctrl.completesOnlyFilter = filter
      }
    }

    function updateRestricted() {
      // when viewing a shared dashboard, any filters that utilize an excluded/private view need to be marked.
      // existing filters that use any of these views are not editable.
      // new filters created will not be able to select these views.
      var restrictedQuestionIds = new Set()
      for (var v of ctrl.survey.views) {
        if (v.type !== View.Types.QUESTION) continue
        var question = v.value
        var view = ctrl.dashboard.views.find(function(v) {
          return v.questionId === question.id
        })
        if (!view || view.private) {
          restrictedQuestionIds.add(question.id)
          question.isDashboardRestricted = ctrl.isShared // only hide from filter UI when viewing shared
        } else {
          question.isDashboardRestricted = false
        }
      }
      // mark all filters that utilize a restricted view
      for (const filter of ctrl.dashboard.filters) {
        filter.restricted = false
        for (const group of filter.groups) {
          for (const rule of group.rules) {
            var restricted =
              restrictedQuestionIds.has(rule.questionId) ||
              _.some(rule.questions.items, function(qid) {
                return restrictedQuestionIds.has(qid)
              })
            if (restricted) {
              filter.restricted = true
            }
          }
        }
      }
    }

    function updateExcludedViews() {
      ctrl.excludedViews = []
      for (const view of ctrl.survey.views) {
        if (![View.Types.QUESTION, View.Types.SECTION].includes(view.type)) {
          continue
        }
        var surveyView = view.value
        var idx = ctrl.dashboard.views.findIndex(function(v) {
          if (view.type === View.Types.QUESTION) {
            return v.questionId === surveyView.id
          }
          return v.sectionId === surveyView.id
        })
        if (idx === -1) {
          ctrl.excludedViews.push({
            type: view.type,
            id: surveyView.id,
            label:
              (view.type === View.Types.QUESTION ? 'Q' : 'S') +
              surveyView.getNumber() +
              '. ' +
              surveyView.title,
          })
        }
      }
    }

    function restoreExcludedViews(items) {
      var dashboard = ctrl.dashboard
      var allFilter =
        _.find(dashboard.filters, { name: ALL_FILTER_NAME }) ||
        _.find(dashboard.filters, isAllFilter)
      var lastView
      _.reverse(items).forEach(function(item) {
        var surveyView = ctrl.survey.views.find(function(v) {
          return v.type === item.type && v.value.id === item.id
        })
        if (!surveyView) return
        var view =
          item.type === View.Types.QUESTION
            ? new DashboardView().fromQuestion(surveyView.value)
            : new DashboardView().fromSection(surveyView.value)
        // give the restored view the "All" filter, as a new dashboard does
        if (allFilter) {
          view.configs.filters.items.push(allFilter.id)
        }
        dashboard.views.unshift(view)
        lastView = view
      })
      updateExcludedViews()
      setView(null, lastView)
    }

    // matches a filter built like a new dashboard's "All", whatever its name
    function isAllFilter(filter) {
      if (filter.groups.length !== 1) return false
      var rules = filter.groups[0].rules
      if (rules.length !== 1) return false
      var rule = rules[0]
      return (
        rule.type === rule.Types.KIND &&
        [ALL_FILTER_KINDS, OLD_ALL_FILTER_KINDS].some(function(kinds) {
          return !_.xor(rule.kinds, kinds).length
        })
      )
    }

    function showExcludedViewsDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-excluded-views-dialog__dialog">',
          '<survey-explorer-excluded-views-dialog ',
            'excluded-views="excludedViews"',
            'on-restore="dialog.close($items)" ',
            'on-close="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          excludedViews: ctrl.excludedViews,
        },
      }
      return glDialog.show(options).then(function(items) {
        restoreExcludedViews(items)
      })
    }

    function watchUnsaved(enabled) {
      if (ctrl.isShared) return
      if (!enabled) {
        $interval.cancel(ctrl.unsavedIntervalId)
        ctrl.isUnsaved = false
        surveyExplorerExitService.setEnabled(false)
        return
      }
      function check() {
        var hasUnsavedTheme =
          ctrl.subscriber && ctrl.subscriber.themeContext.isUnsaved()
        ctrl.isUnsaved = ctrl.dashboard.isUnsaved() || hasUnsavedTheme
        // var data = JSON.stringify(ctrl.dashboard.serialize(true))
        // ctrl.isUnsaved = ctrl.lastSavedData !== data
        surveyExplorerExitService.setEnabled(ctrl.isUnsaved)
      }
      check()
      if (ctrl.unsavedIntervalId) {
        $interval.cancel(ctrl.unsavedIntervalId)
      }
      // ctrl.isUnsaved = false
      // ctrl.lastSavedData = JSON.stringify(ctrl.dashboard.serialize(true))
      ctrl.unsavedIntervalId = $interval(check, 1000)
    }

    function setTab(tab) {
      if (ctrl.isMovingItems) return
      ctrl.tab = tab
      ctrl.anchorIndex = null
    }

    function setView(e, view, skipScroll) {
      if (e && e._menu) return

      ctrl.view = view
      ctrl.question = null
      ctrl.section = null
      ctrl.sectionMedia = null

      if (!view) return

      if (!skipScroll) {
        ensureSelectedViewVisible()
      }

      if (view.type === 'question') {
        ctrl.question = questionsById[view.questionId]
      }
      if (isSectionView(view)) {
        ctrl.section = sectionsById[view.sectionId]
      }

      // ctrl.chartRebuild = true

      build()
    }

    function isSectionView(view) {
      return view && view.type === 'section'
    }

    function scrollSidebarToTarget(tab, targetIdx) {
      var sidebarClass
      if (tab === 'views') {
        sidebarClass = '.survey-explorer__views-list'
      }
      if (tab === 'filters') {
        sidebarClass = '.survey-explorer__filters-list'
      }
      if (!sidebarClass) return

      var sidebar = document.querySelector(sidebarClass)
      var target = document.querySelector(
        `.${ctrl.itemClassPrefix}${targetIdx}`
      )
      if (!sidebar || !target) return

      var sidebarRect = sidebar.getBoundingClientRect()
      var targetRect = target.getBoundingClientRect()
      var viewTop = targetRect.top - sidebarRect.top + sidebar.scrollTop
      var viewBottom = viewTop + targetRect.height
      var visibleTop = sidebar.scrollTop
      var visibleBottom = visibleTop + sidebar.clientHeight

      if (viewTop < visibleTop || viewBottom > visibleBottom) {
        var nextTop = Math.max(viewTop - sidebar.clientHeight / 2, 0)

        if (sidebar.scrollTo) {
          sidebar.scrollTo({ top: nextTop, behavior: 'smooth' })
        } else {
          sidebar.scrollTop = nextTop
        }
      }
    }

    function ensureSelectedViewVisible() {
      $timeout(function() {
        scrollSidebarToTarget('views', getViewIndex())
      }, 10)
    }

    function getViewIndex() {
      return _.findIndex(ctrl.dashboard.views, { id: ctrl.view.id })
    }

    function cycleView(amount) {
      var newIdx = getViewIndex() + amount
      if (newIdx >= ctrl.dashboard.views.length) {
        newIdx = 0
      }
      if (newIdx < 0) {
        newIdx = ctrl.dashboard.views.length - 1
      }
      var view = ctrl.dashboard.views[newIdx]
      setView(null, view)
    }

    // The variable-centric slot model for the current view: which variables are
    // available, their pinnable items, and which (if any) is pinned.
    function buildSlotModel() {
      ctrl.slotModel = { categories: [], items: {}, pinnedCategory: null }

      var view = ctrl.view
      if (!view) return ctrl.slotModel

      var categories = []
      if (view.statements.length) categories.push('statements')
      categories.push('choices')
      if (view.ranks.length) categories.push('ranks')
      categories.push('filters')
      function toItems(list) {
        return list
          .filter(function(item) {
            return !item.redact
          })
          .map(function(item) {
            return { id: item.id, label: item.label }
          })
      }
      // Invariant: a question never has both statements and ranks, so at most 3
      // variables are available. The single `target` field can only represent
      // one off-axis variable, so a 4th would silently corrupt slot state.
      // Surface it rather than fail quietly if a future question type breaks the
      // assumption the slot mapping (surveyExplorerSlotsService) relies on.
      if (categories.length > 3) {
        console.warn(
          'surveyExplorerSlotsService: expected <=3 slot variables, got',
          categories
        )
      }
      ctrl.slotModel = {
        categories: categories,
        items: {
          statements: toItems(view.configs.statements.items),
          choices: toItems(view.configs.choices.items),
          ranks: toItems(view.configs.ranks.items),
        },
        // All schema<->slot inference lives in the mapper: the pinned variable is
        // the one not on either axis, derived the same way the renderer reads
        // `target`.
        pinnedCategory: surveyExplorerSlotsService.getPinnedCategory(
          view.slots,
          categories
        ),
      }
    }

    function buildSlotOptions() {
      var view = ctrl.view

      ctrl.slotOptions = {}
      ctrl.slotOptions.loop = []
      if (view.loops.length) {
        for (var loop of view.configs.loops.items) {
          if (loop.redact) continue
          ctrl.slotOptions.loop.push({
            id: loop.id,
            label: loop.label,
          })
        }
      }
      // Build the per-variable dropdown options once here (reading the slot model
      // assembled by buildSlotModel) so the dropdowns bind to stable arrays —
      // re-deriving them on every digest causes $digest loops.
      ctrl.slotModel.categories.forEach(function(category) {
        ctrl.slotOptions[category] = surveyExplorerSlotsService.getOptions(
          category,
          ctrl.slotModel.categories,
          ctrl.slotModel.items[category]
        )
      })
      var hasSum =
        ctrl.question.type === Question.Types.CONSTANT_SUM ||
        view.configs.choices.combineWeighted

      var isConstantSum = ctrl.question.type === Question.Types.CONSTANT_SUM

      ctrl.slotOptions.format = [
        {
          id: 'count',
          label: 'Count',
          hidden: false,
        },
        {
          id: 'sum',
          label: 'Sum',
          hidden: false, // !hasSum,
        },
        {
          id: 'average',
          label: 'Average',
          hidden: false, // !hasSum,
        },
        {
          id: 'average-incl',
          label: 'Average (incl. 0)',
          hidden: !isConstantSum,
        },
        {
          id: 'sum-percent',
          label: 'Sum %',
          hidden: !isConstantSum,
        },
        {
          id: 'cell-percent',
          label: 'Cell %',
          hidden: false,
        },
        {
          id: 'row-percent',
          label: 'Row %',
          hidden: false,
        },
        {
          id: 'col-percent',
          label: 'Column %',
          hidden: false,
        },
        {
          id: 'total-percent',
          label: 'Total %',
          hidden: false,
        },
      ]
    }

    function duplicateViews(views) {
      var firstClonedView = null
      views.forEach(function(view) {
        var idx = ctrl.dashboard.views.indexOf(view)
        var newView = view.duplicate()
        firstClonedView = firstClonedView || newView
        ctrl.dashboard.views.splice(idx + 1, 0, newView)
        setSelected(newView, true)
        setSelected(view, false)
      })
      if (firstClonedView) {
        setView(null, firstClonedView)
      }
    }

    function togglePrivateViews(views, isPrivate) {
      views.forEach(function(view) {
        view.private = isPrivate
      })
    }

    function removeViews(views) {
      views.forEach(function(view) {
        var idx = ctrl.dashboard.views.indexOf(view)
        if (ctrl.view === view) {
          var nextIdx =
            idx === ctrl.dashboard.views.length - 1 ? idx - 1 : idx + 1
          setView(null, ctrl.dashboard.views[nextIdx])
        }
        ctrl.dashboard.views.splice(idx, 1)
      })
      updateExcludedViews()
    }

    function build() {
      if (isSectionView(ctrl.view)) {
        buildSection()
        return
      }
      buildSlotModel()
      buildSlotOptions()
      buildData()
      ctrl.slotOptions.sort = buildSortOptions()
      applySort()
      if (hasTable(ctrl.view)) {
        buildTable()
      }
      if (hasChart(ctrl.view)) {
        buildChart()
      }
      if (hasList(ctrl.view)) {
        buildList()
      }
      if (hasCloud(ctrl.view)) {
        buildCloud()
      }
      if (hasImages(ctrl.view)) {
        buildImages()
      }
      if (hasMap(ctrl.view)) {
        buildMap()
      }
      if (hasChoiceCapture(ctrl.view)) {
        buildChoiceCapture()
      }
    }

    function buildSection() {
      ctrl.theme = themeService.resolveTheme(
        ctrl.view.theme,
        ctrl.profile.themeContext,
        ctrl.dashboard.theme
      )
      buildSectionMedia()
    }

    function buildSectionMedia() {
      var section = ctrl.section
      ctrl.sectionMedia = null
      if (!section || !section.mediaType) return

      var media = {
        type: section.mediaType,
      }
      switch (section.mediaType) {
        case section.MediaTypes.VIDEO:
          if (!section.youTubeVideoUrl) return
          media.youTubeVideoUrl = $sce.trustAsResourceUrl(
            glUtils.addParamsV2(section.youTubeVideoUrl, {
              rel: 0,
              modestbranding: 1,
            })
          )
          break
        case section.MediaTypes.VIDEO_UPLOAD:
          if (!section.video) return
          media.video = section.video
          break
        case section.MediaTypes.AUDIO:
          if (!section.audioUrl) return
          media.audioUrl = section.audioUrl
          break
        case section.MediaTypes.IMAGE:
          if (!section.imageUrl) return
          media.imageUrl = section.imageUrl
          break
        case section.MediaTypes.IFRAME:
          if (!section.iframeUrl) return
          media.iframeUrl = $sce.trustAsResourceUrl(section.iframeUrl)
          break
        default:
          return
      }
      ctrl.sectionMedia = media
    }

    function buildSortOptions() {
      var data = ctrl.data
      var rowsLen = (data && data.rows && data.rows.items && data.rows.items.length) || 0 // prettier-ignore
      var colsLen = (data && data.cols && data.cols.items && data.cols.items.length) || 0 // prettier-ignore
      var rowSubs = []
      for (var r = 0; r < rowsLen; r++) {
        rowSubs.push({ id: String(r), label: 'Row ' + (r + 1) })
      }
      rowSubs.push({ id: 'total', label: 'Total' })
      var colSubs = []
      for (var c = 0; c < colsLen; c++) {
        colSubs.push({ id: String(c), label: 'Column ' + (c + 1) })
      }
      colSubs.push({ id: 'total', label: 'Total' })
      return [
        { id: 'manual', label: 'Manual', subOptions: [] },
        { id: 'row-asc', label: 'Row Asc', subOptions: colSubs },
        { id: 'row-desc', label: 'Row Desc', subOptions: colSubs },
        { id: 'col-asc', label: 'Column Asc', subOptions: rowSubs },
        { id: 'col-desc', label: 'Column Desc', subOptions: rowSubs },
      ]
    }

    function getCellSortValue(cell, format) {
      if (!cell) return 0
      if (format === 'count') return cell.count || 0
      if (format === 'sum') return cell.sum || 0
      if (format === 'average') return cell.average || 0
      if (format === 'average-incl') return cell.averageIncl || 0
      if (format === 'sum-percent') return cell.sumPercent || 0
      if (format === 'cell-percent') return cell.cellPercent || 0
      if (format === 'row-percent') return cell.rowPercent || 0
      if (format === 'col-percent') return cell.colPercent || 0
      if (format === 'total-percent') return cell.totalPercent || 0
      return cell.count || 0
    }

    function applySort() {
      var view = ctrl.view
      var sort = view.slots.sort || 'manual'
      if (sort === 'manual') return
      if (!ctrl.data || !ctrl.data.rows || !ctrl.data.cols) return

      // parse composite "<row|col>-<asc|desc>[:by]" — by is 'total' or numeric index
      var parts = (sort + '').split(':')
      var dirPart = parts[0]
      var by = parts[1] != null ? parts[1] : 'total'
      if (!/^(row|col)-(asc|desc)$/.test(dirPart)) return

      var axis = dirPart.indexOf('row-') === 0 ? 'rows' : 'cols'
      var dir = dirPart.indexOf('-asc') !== -1 ? 1 : -1
      var slotType = axis === 'rows' ? view.slots.rows : view.slots.columns
      if (!slotType) return

      var dataAxis = ctrl.data[axis]
      var items = dataAxis.items
      if (!items || items.length < 2) return

      var matrix = ctrl.data.matrix
      var format = view.slots.format
      var byIndex = by === 'total' ? null : Number(by)
      var sigTest = ctrl.dashboard.significanceTest
      var isSigTestEnabled =
        sigTest.enabled && (!ctrl.isShared || !sigTest.isHiddenFromShared)
      var sortTotalAsCellPercent =
        isSigTestEnabled &&
        format === 'cell-percent' &&
        ((axis === 'rows' && ctrl.data.cols.type === 'filter') ||
          (axis === 'cols' && ctrl.data.rows.type === 'filter'))
      // fall back to total if index is out of range
      if (byIndex !== null) {
        var crossLen
        if (axis === 'rows') {
          crossLen = (matrix && matrix[0] && matrix[0].length) || 0
        } else {
          crossLen = (matrix && matrix.length) || 0
        }
        if (isNaN(byIndex) || byIndex < 0 || byIndex >= crossLen) {
          byIndex = null
        }
      }

      function sortKey(idx) {
        if (byIndex === null) {
          if (sortTotalAsCellPercent) {
            var total = items[idx].cellPercentTotal
            return total ? total.cellPercent || 0 : 0
          }
          return items[idx].count || 0
        }
        var cell
        if (axis === 'rows') {
          cell = matrix[idx] && matrix[idx][byIndex]
        } else {
          cell = matrix[byIndex] && matrix[byIndex][idx]
        }
        return getCellSortValue(cell, format)
      }

      // build an index permutation sorted by the chosen key
      var indices = items.map(function(_, i) {
        return i
      })
      indices.sort(function(a, b) {
        return (sortKey(a) - sortKey(b)) * dir
      })

      // capture positional colors so they don't move with items when sorted
      var origColors = items.map(function(it) {
        return it.color
      })

      // reorder data axis items
      dataAxis.items = indices.map(function(i) {
        return items[i]
      })

      // restore colors by position (color stays with slot, not with item)
      dataAxis.items.forEach(function(item, idx) {
        item.color = origColors[idx]
      })

      // reorder matrix accordingly
      var matrix = ctrl.data.matrix
      if (matrix && matrix.length) {
        if (axis === 'rows') {
          ctrl.data.matrix = indices.map(function(i) {
            return matrix[i]
          })
        } else {
          ctrl.data.matrix = matrix.map(function(row) {
            return indices.map(function(i) {
              return row[i]
            })
          })
        }
      }

      // reorder underlying config items so the mods/filters dialogs reflect the sort
      var sortedIds = dataAxis.items.map(function(it) {
        return it.value && it.value.id
      })
      var configItems = view.configs[slotType] && view.configs[slotType].items
      if (!configItems || !configItems.length) return

      var isFilters = slotType === 'filters'
      var keyOf = function(entry) {
        return isFilters ? entry : entry.id
      }
      var sortedSet = new Set(sortedIds)
      var sortedById = {}
      for (var entry of configItems) {
        sortedById[keyOf(entry)] = entry
      }
      var sortedEntries = sortedIds
        .filter(function(id) {
          return sortedById.hasOwnProperty(id)
        })
        .map(function(id) {
          return sortedById[id]
        })
      var leftover = configItems.filter(function(entry) {
        return !sortedSet.has(keyOf(entry))
      })
      var next = sortedEntries.concat(leftover)
      configItems.length = 0
      for (var entry of next) configItems.push(entry)
    }

    function buildData() {
      console.time('buildData')
      var view = ctrl.view
      var prefilters = getAllPrefilters()
      var csv = ctrl.csv.filter(function(row) {
        return _.every(prefilters, function(filter) {
          return filter.match(row)
        })
      })
      // the completesOnly setting (default) can be switched off to include exits & overquotas too
      if (ctrl.dashboard.completesOnly) {
        csv = csv.filter(function(row) {
          return ctrl.completesOnlyFilter.match(row)
        })
      }
      ctrl.totalCount = csv.length
      ctrl.data = {
        // rows: {
        //   type: 'choice',
        //   items: [{ color, value: choice, count }],
        // },
        // cols: {
        //   type: 'filter',
        //   items: [{ color, value: filter, count }],
        // },
        // matrix: [
        //   [{ count: 12, rowPercent: 0.5, colPerc: 1 }],
        // ],
        // count: 0, // answered
      }
      var questionId = view.questionId
      var questionType = view.questionType
      var loop = view.slots.loop || '-'
      var rows = view.slots.rows
      var cols = view.slots.columns
      var tuple = [rows, cols]

      ctrl.theme = themeService.resolveTheme(
        view.theme,
        ctrl.profile.themeContext,
        ctrl.dashboard.theme
      )

      function getActiveFilterItems() {
        var filterItems = view.configs.filters.items.map(function(filterId) {
          return { filter: ctrl.filtersById[filterId] }
        })
        if (ctrl.isShared) {
          filterItems = filterItems.filter(function(item) {
            return !item.filter.private
          })
        }
        return filterItems
      }

      function countRows(match) {
        var n = 0
        for (var row of csv) {
          if (match(row)) n++
        }
        return n
      }

      function collectRespondents(match) {
        var set = new Set()
        for (var row of csv) {
          if (match(row)) {
            var respondentId = row[ctrl.datapack.mappings.columns.id]
            set.add(respondentId)
          }
        }
        return set
      }

      function getRowWeight(row) {
        var respondentId = row[ctrl.datapack.mappings.columns.id]
        return ctrl.dashboard.weightScheme.getWeight(respondentId)
      }

      // "shown" base helpers.
      // A respondent was *shown* a choice/statement when they saw the question
      // and it wasn't hidden from them (display logic / piping). The hcid/hsid
      // columns are mapped-value columns: after setupDatapack() translation a
      // hidden cell holds the hidden option's id and a shown cell is empty
      // (absent column = never hidden), so any truthy value means hidden.
      function getQuestionColIdx(suffix) {
        var columns = ctrl.datapack.mappings.columns
        var idx = columns[`q_${questionId}_l_${loop}_${suffix}`]
        if (idx === undefined) {
          idx = columns[`q_${questionId}_l_-_${suffix}`]
        }
        return idx
      }

      var seenIdx = getQuestionColIdx('seen')

      // returns a matcher for respondents who saw the question and were shown
      // the given choice (any of its original options) and/or statement.
      // pass null to skip either check.
      function makeShownMatcher(choice, statementId) {
        var hcidIdxs =
          choice &&
          choice.optionIds.map(function(optionId) {
            return getQuestionColIdx(`hcid_${optionId}`)
          })
        var hsidIdx = statementId
          ? getQuestionColIdx(`hsid_${statementId}`)
          : undefined
        return function(row) {
          if (seenIdx !== undefined && row[seenIdx] !== '1') return 0
          if (hsidIdx !== undefined && row[hsidIdx]) return 0
          if (hcidIdxs) {
            var anyOptionShown = _.some(hcidIdxs, function(idx) {
              return idx === undefined || !row[idx]
            })
            if (!anyOptionShown) return 0
          }
          return 1
        }
      }

      function subtractExcludedChoices(matchBase, statementId) {
        var excluded = view.configs.choices.items.filter(function(choice) {
          return choice.redact === 'exclude'
        })
        if (!excluded.length) return matchBase
        var included = view.configs.choices.items.filter(function(choice) {
          return choice.redact !== 'exclude'
        })
        var matchExcluded = makeAnyChoiceMatcher(excluded, statementId)
        var matchIncluded = makeAnyChoiceMatcher(included, statementId)
        return function(row) {
          if (!matchBase(row)) return 0
          if (matchExcluded(row) && !matchIncluded(row)) return 0
          return 1
        }
      }

      function makeAnyChoiceMatcher(choices, statementId) {
        if (view.shownBase) {
          var matchers = choices.map(function(choice) {
            return makeShownMatcher(choice, statementId)
          })
          return function(row) {
            return _.some(matchers, function(match) {
              return match(row)
            })
          }
        }
        if (questionType === Question.Types.NUMERIC) {
          var numberIdx =
            ctrl.datapack.mappings.columns[`q_${questionId}_l_${loop}_number`]
          var numericIds = _.flatten(_.map(choices, 'optionIds'))
          return function(row) {
            return (
              numberIdx !== undefined && numericIds.includes(row[numberIdx])
            )
          }
        }
        var isConstantSum = questionType === Question.Types.CONSTANT_SUM
        var idxs = []
        for (var choice of choices) {
          for (var optionId of choice.optionIds) {
            var key
            if (isConstantSum) {
              key = statementId
                ? `q_${questionId}_l_${loop}_s_${statementId}_c_${optionId}_number`
                : `q_${questionId}_l_${loop}_c_${optionId}_number`
            } else {
              key = statementId
                ? `q_${questionId}_l_${loop}_s_${statementId}_c_${optionId}_selected`
                : `q_${questionId}_l_${loop}_c_${optionId}_selected`
            }
            var idx = ctrl.datapack.mappings.columns[key]
            if (idx !== undefined) idxs.push(idx)
          }
        }
        return function(row) {
          return _.some(idxs, function(idx) {
            return isConstantSum
              ? row[idx] !== '' && row[idx] != null
              : row[idx] === '1'
          })
        }
      }

      function makeCell(match, matchAll, matchAnswered) {
        var count = 0
        var countIncl = 0
        var sum = 0
        var totalSum = 0
        var total = 0
        for (var row of csv) {
          var value = match(row)
          var weight = getRowWeight(row)
          if (value) count += weight
          sum += value * weight
          if (matchAll) {
            var allValue = matchAll(row)
            if (allValue) countIncl += weight
            totalSum += allValue * weight
          }
          if (matchAnswered && matchAnswered(row)) {
            total += weight
          }
        }
        return {
          count: count,
          countIncl: matchAll ? countIncl : null,
          sum: sum,
          totalSum: matchAll ? totalSum : null,
          total: matchAnswered ? total : null,
          weight: null,
          average: null,
          sumPercent: null,
          averageIncl: null,
          cellPercent: null,
          rowPercent: null,
          colPercent: null,
          totalPercent: null,
          highlight: null,
        }
      }

      function assignCellPercentTotal(item, match, matchAnswered) {
        var sigTest = ctrl.dashboard.significanceTest
        var isSigTestEnabled =
          sigTest.enabled && (!ctrl.isShared || !sigTest.isHiddenFromShared)
        if (view.slots.format !== 'cell-percent' || !isSigTestEnabled) return
        var totalCell = makeCell(match, null, matchAnswered)
        totalCell.cellPercent = totalCell.total
          ? totalCell.count / totalCell.total
          : 0
        item.cellPercentTotal = totalCell
      }

      function getWeightedRespondentCount(respondents) {
        var count = 0
        for (const id of respondents) {
          count += ctrl.dashboard.weightScheme.getWeight(id)
        }
        return count
      }

      function finalize() {
        var matrix = ctrl.data.matrix
        var numRows = matrix.length
        var numCols = matrix.length ? matrix[0].length : 0

        // answered counts across each row and column
        ctrl.data.rows.items.forEach(function(row) {
          var primary = row.respondents
          var secondaries = new Set()
          ctrl.data.cols.items.forEach(function(col) {
            for (const id of col.respondents) {
              secondaries.add(id)
            }
          })
          var intersected = primary.intersection(secondaries)
          row.count = getWeightedRespondentCount(intersected)
          row.percent = row.count / ctrl.data.count || 0 // NaN fallback
        })
        ctrl.data.cols.items.forEach(function(col) {
          var primary = col.respondents
          var secondaries = new Set()
          ctrl.data.rows.items.forEach(function(row) {
            for (const id of row.respondents) {
              secondaries.add(id)
            }
          })
          var intersected = primary.intersection(secondaries)
          col.count = getWeightedRespondentCount(intersected)
          col.percent = col.count / ctrl.data.count || 0 // NaN fallback
        })

        // cell values
        for (let r = 0; r < numRows; r++) {
          for (let c = 0; c < numCols; c++) {
            var cell = matrix[r][c]
            var rowItem = ctrl.data.rows.items[r]
            var colItem = ctrl.data.cols.items[c]
            cell.average = cell.sum / cell.count // NaN fallback intentional (div by 0 = NaN → shown as 0 downstream)
            cell.sumPercent = cell.totalSum ? cell.sum / cell.totalSum : 0
            cell.averageIncl = cell.countIncl ? cell.sum / cell.countIncl : 0
            cell.cellPercent = cell.total ? cell.count / cell.total : 0
            cell.rowPercent = cell.count / rowItem.count || 0 // NaN fallback
            cell.colPercent = cell.count / colItem.count || 0 // NaN fallback
            cell.totalPercent = cell.count / ctrl.data.count || 0 // NaN fallback
          }
        }

        removeHidden()
        applyHighlights()
      }

      function flipMatrix() {
        var matrix = ctrl.data.matrix
        if (!matrix.length) return
        let flipped = []
        for (let col = 0; col < matrix[0].length; col++) {
          let newRow = []
          for (let row = 0; row < matrix.length; row++) {
            newRow.push(matrix[row][col])
          }
          flipped.push(newRow)
        }
        ctrl.data.matrix = flipped
      }

      function flip() {
        flipMatrix()
        var newCols = ctrl.data.rows
        var newRows = ctrl.data.cols
        ctrl.data.rows = newRows
        ctrl.data.cols = newCols
      }

      function removeHidden() {
        // removes via redact=hide
        // the numbers are calculated with them in, but theyre removed after.
        // note: we iterate backwards since we will be removing things
        for (let i = ctrl.data.cols.items.length - 1; i >= 0; i--) {
          const item = ctrl.data.cols.items[i]
          if (item.value.redact === 'hide') {
            // remove item
            ctrl.data.cols.items.splice(i, 1)
            // remove from matrix
            for (const row of ctrl.data.matrix) {
              row.splice(i, 1)
            }
          }
        }
        // same for rows
        for (let i = ctrl.data.rows.items.length - 1; i >= 0; i--) {
          const item = ctrl.data.rows.items[i]
          if (item.value.redact === 'hide') {
            // remove item
            ctrl.data.rows.items.splice(i, 1)
            // remove from matrix
            ctrl.data.matrix.splice(i, 1)
          }
        }
      }

      function applyHighlights() {
        // highlight cells when significance test is enabled and result is significant
        // sig test only applied when filters is selected in rows or columns
        // and when selected values is row%, column%, or cell%
        var format = view.slots.format
        var sigTest = ctrl.dashboard.significanceTest
        var isSigTestEnabled =
          sigTest.enabled && (!ctrl.isShared || !sigTest.isHiddenFromShared)

        if (
          !isSigTestEnabled ||
          !tuple.includes('filters') ||
          !['row-percent', 'col-percent', 'cell-percent'].includes(format)
        ) {
          return
        }

        var matrix = ctrl.data.matrix
        var numRows = matrix.length
        var numCols = matrix.length ? matrix[0].length : 0
        for (let r = 0; r < numRows; r++) {
          for (let c = 0; c < numCols; c++) {
            var row = ctrl.data.rows.items[r]
            var col = ctrl.data.cols.items[c]
            var cell = matrix[r][c]
            var subsetN = cell.count
            var subsetBase
            var totalCell
            var totalN
            var totalBase

            if (format === 'cell-percent') {
              totalCell = ctrl.data.rows.type === 'filter' ? col : row
              if (!totalCell.cellPercentTotal) continue
              subsetBase = cell.total
              totalN = totalCell.cellPercentTotal.count
              totalBase = totalCell.cellPercentTotal.total
            } else {
              subsetBase = format === 'row-percent' ? row.count : col.count
              totalCell = format === 'row-percent' ? col : row
              totalN = totalCell.count
              totalBase = ctrl.data.count
            }
            var result = sigTest.testSubset(
              subsetN,
              subsetBase,
              totalN,
              totalBase
            )
            cell.highlight =
              result === 'HIGHER' ? 'green' : result === 'LOWER' ? 'red' : null

            // highlight total cell if not already
            if (cell.highlight && !totalCell.highlight) {
              totalCell.highlight = 'grey'
            }
          }
        }
      }

      // total count (answered) for views with empty tuple
      if (!_.compact(tuple).length) {
        var questionId = view.questionId
        var key = `q_${questionId}_l_${loop}_answered`
        var idx = ctrl.datapack.mappings.columns[key]
        ctrl.data.count = countRows(function(row) {
          return ~~row[idx]
        })
        ctrl.data.isRowsCount = true
      }

      // ensure merged choices are represented in a csv column
      function ensureMergeCol(choices, statementIds) {
        // if (
        //   tuple.includes('choices') &&
        //   [
        //     Question.Types.CHOICE,
        //     Question.Types.MATRIX,
        //     Question.Types.SCALE,
        //     Question.Types.NPS,
        //     Question.Types.MOOD,
        //     Question.Types.RATING,
        //   ].includes(view.questionType)
        // ) {
        function ensure(choice, statementId) {
          var key
          var numericId = false
          if (questionType === Question.Types.NUMERIC) {
            key = `q_${questionId}_l_${loop}_number_${choice.id}`
            numericId = choice.id
          } else if (questionType === Question.Types.CONSTANT_SUM) {
            key = statementId
              ? `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_number`
              : `q_${questionId}_l_${loop}_c_${choice.id}_number`
          } else {
            key = statementId
              ? `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_selected`
              : `q_${questionId}_l_${loop}_c_${choice.id}_selected`
          }
          if (!ctrl.datapack.mappings.columns.hasOwnProperty(key)) {
            const idx = ++ctrl.datapack.refCounts.columns
            ctrl.datapack.mappings.columns[key] = idx
            // NOTE: we're updating the entire csv here, not just the subset!
            for (const row of ctrl.csv) {
              let total = 0
              let anySelected = false
              for (const optionId of choice.optionIds) {
                var _key
                var _numericId = false
                if (questionType === Question.Types.NUMERIC) {
                  _key = `q_${questionId}_l_${loop}_number`
                  _numericId = optionId
                } else if (questionType === Question.Types.CONSTANT_SUM) {
                  _key = statementId
                    ? `q_${questionId}_l_${loop}_s_${statementId}_c_${optionId}_number`
                    : `q_${questionId}_l_${loop}_c_${optionId}_number`
                } else {
                  _key = statementId
                    ? `q_${questionId}_l_${loop}_s_${statementId}_c_${optionId}_selected`
                    : `q_${questionId}_l_${loop}_c_${optionId}_selected`
                }
                const _idx = ctrl.datapack.mappings.columns[_key]
                if (questionType === Question.Types.CONSTANT_SUM) {
                  total += +row[_idx] || 0
                } else {
                  const _selected =
                    _numericId !== false
                      ? row[_idx] === _numericId
                      : row[_idx] === '1'
                  if (_selected) anySelected = true
                }
              }
              row[idx] = anySelected
                ? numericId
                  ? numericId
                  : '1'
                : total + ''
            }
          }
        }
        for (const choice of choices) {
          if (choice.optionIds.length > 1) {
            if (statementIds && statementIds.length) {
              for (const statementId of statementIds) {
                ensure(choice, statementId)
              }
            } else {
              ensure(choice)
            }
          }
        }
        // }
      }

      // ensure statement-level answered cols are represented in a csv column
      // answered = selected any ORIGINAL option in the statement (for
      // constant sum: any non-empty number entry, "0" counts as answered)
      function ensureAnsweredCol(statementIds) {
        function ensure(statementId) {
          var key = `q_${questionId}_l_${loop}_s_${statementId}_answered`
          if (!ctrl.datapack.mappings.columns.hasOwnProperty(key)) {
            const idx = ++ctrl.datapack.refCounts.columns
            ctrl.datapack.mappings.columns[key] = idx
            // NOTE: we're updating the entire csv here, not just the subset!
            for (const row of ctrl.csv) {
              let answered = false
              for (const choice of view.choices) {
                var _key
                if (questionType === Question.Types.CONSTANT_SUM) {
                  _key = `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_number`
                } else {
                  _key = `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_selected`
                }
                const _idx = ctrl.datapack.mappings.columns[_key]
                if (_idx === undefined) continue
                if (questionType === Question.Types.CONSTANT_SUM) {
                  if (row[_idx] !== '' && row[_idx] != null) answered = true
                } else {
                  if (row[_idx] === '1') answered = true
                }
                if (answered) break
              }
              row[idx] = answered ? '1' : '0'
            }
          }
        }
        for (const statementId of statementIds || []) {
          if (statementId) ensure(statementId)
        }
      }

      function processTotal() {
        // total count (answered) across row and column except filters
        const allRespondents = new Set()
        const filterRespondents = new Set()
        const groups = [
          { items: ctrl.data.rows.items, type: ctrl.data.rows.type },
          { items: ctrl.data.cols.items, type: ctrl.data.cols.type },
        ]
        for (const { items, type } of groups) {
          for (const item of items) {
            for (const id of item.respondents) {
              if (type === 'filter') {
                filterRespondents.add(id)
              } else {
                allRespondents.add(id)
              }
            }
          }
        }
        const result = filterRespondents.size
          ? allRespondents.intersection(filterRespondents)
          : allRespondents
        ctrl.data.count = getWeightedRespondentCount(result)
      }

      function processCombinedWeighted(choicesAreRows) {
        if (view.configs.choices.combineWeighted) {
          var matrix = ctrl.data.matrix
          var row = []
          var allRespondents = new Set()
          var combinedCellPercentTotal = null
          for (var item of ctrl.data.rows.items) {
            if (!item.cellPercentTotal) continue
            if (!combinedCellPercentTotal) {
              combinedCellPercentTotal = {
                count: 0,
                total: item.cellPercentTotal.total,
                cellPercent: 0,
              }
            }
            combinedCellPercentTotal.count += item.cellPercentTotal.count
          }
          if (combinedCellPercentTotal && combinedCellPercentTotal.total) {
            combinedCellPercentTotal.cellPercent =
              combinedCellPercentTotal.count / combinedCellPercentTotal.total
          }
          for (let c = 0; c < matrix[0].length; c++) {
            let totalWeightedSum = 0
            let count = 0
            for (let r = 0; r < matrix.length; r++) {
              var cell = matrix[r][c]
              totalWeightedSum += cell.count * cell.weight
              count += cell.count
            }
            // var weightedAvg = totalWeightedSum / count
            row.push({
              count: count,
              sum: totalWeightedSum,
              total: matrix[0][c] ? matrix[0][c].total : null,
              // ...rest is calculated via finalize()
            })
          }
          var allRespondents = new Set()
          for (var item of ctrl.data.rows.items) {
            for (const respondentId of item.respondents) {
              allRespondents.add(respondentId)
            }
          }
          ctrl.data.matrix = [row]
          ctrl.data.rows = {
            type: 'choice',
            items: [
              {
                color: getStandardColor(0),
                value: {
                  label: view.configs.choices.combineWeightedLabel || 'Total',
                },
                count: ctrl.data.count,
                respondents: allRespondents,
                cellPercentTotal: combinedCellPercentTotal,
              },
            ],
          }
        }
      }

      //
      // (choices x filters) + ?statement|rank
      //

      if (tuple.includes('choices') && tuple.includes('filters')) {
        var choices = view.configs.choices.items.filter(function(choice) {
          return choice.redact !== 'exclude'
        })
        var filterItems = getActiveFilterItems()
        var statementId = view.statements.length ? view.slots.target : null
        var rankId = view.ranks.length ? view.slots.target : null
        var matrix = []
        ensureMergeCol(choices, [statementId])
        // rows
        {
          var linear = hasLinearChoiceColors(questionId)
          ctrl.data.rows = {
            type: 'choice',
            items: choices.map(function(choice, choiceIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(choice, statementId)
              } else {
                var key
                var numericId = false
                if (questionType === Question.Types.NUMERIC) {
                  const isMerged = choice.optionIds.length > 1
                  key = isMerged
                    ? `q_${questionId}_l_${loop}_number_${choice.id}`
                    : `q_${questionId}_l_${loop}_number`
                  numericId = choice.id
                } else if (questionType === Question.Types.CONSTANT_SUM) {
                  key = statementId
                    ? `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_number`
                    : `q_${questionId}_l_${loop}_c_${choice.id}_number`
                } else {
                  key = statementId
                    ? `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_selected`
                    : `q_${questionId}_l_${loop}_c_${choice.id}_selected`
                }
                var idx = ctrl.datapack.mappings.columns[key]
                var rankIdx
                if (rankId) {
                  var key = `q_${questionId}_l_${loop}_c_${choice.id}_rank`
                  rankIdx = ctrl.datapack.mappings.columns[key]
                }
                matchBase = function(row) {
                  if (numericId !== false) {
                    return row[idx] === numericId ? 1 : 0
                  } else if (rankId) {
                    return row[rankIdx] === rankId ? 1 : 0
                  } else {
                    return ~~row[idx]
                  }
                }
              }
              return {
                color: linear ? getLinearColor(choiceIdx, choices.length) : getStandardColor(choiceIdx), // prettier-ignore
                value: choice,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        // cols
        {
          ctrl.data.cols = {
            type: 'filter',
            items: filterItems.map(function(filterItem, idx) {
              return {
                color: getStandardColor(idx),
                global: filterItem.global,
                value: filterItem.filter,
                count: 0,
                respondents: collectRespondents(function(row) {
                  return filterItem.filter.match(row)
                }),
              }
            }),
          }
        }
        // cells
        var allChoiceIdxs = null
        if (questionType === Question.Types.CONSTANT_SUM) {
          allChoiceIdxs = choices.map(function(ch) {
            var k = statementId
              ? `q_${questionId}_l_${loop}_s_${statementId}_c_${ch.id}_number`
              : `q_${questionId}_l_${loop}_c_${ch.id}_number`
            return ctrl.datapack.mappings.columns[k]
          })
        }
        var matchViewBase
        if (view.shownBase) {
          matchViewBase = makeShownMatcher(null, statementId)
        } else {
          ensureAnsweredCol([statementId])
          var answeredKey = statementId
            ? `q_${questionId}_l_${loop}_s_${statementId}_answered`
            : `q_${questionId}_l_${loop}_answered`
          var answeredIdx = ctrl.datapack.mappings.columns[answeredKey]
          matchViewBase = function(row) {
            return ~~row[answeredIdx] ? 1 : 0
          }
        }
        matchViewBase = subtractExcludedChoices(matchViewBase, statementId)
        for (var choice of choices) {
          var row = []
          var key
          var numericId = false
          if (questionType === Question.Types.NUMERIC) {
            const isMerged = choice.optionIds.length > 1
            key = isMerged
              ? `q_${questionId}_l_${loop}_number_${choice.id}`
              : `q_${questionId}_l_${loop}_number`
            numericId = choice.id
          } else if (questionType === Question.Types.CONSTANT_SUM) {
            key = statementId
              ? `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_number`
              : `q_${questionId}_l_${loop}_c_${choice.id}_number`
          } else {
            key = statementId
              ? `q_${questionId}_l_${loop}_s_${statementId}_c_${choice.id}_selected`
              : `q_${questionId}_l_${loop}_c_${choice.id}_selected`
          }
          var idx = ctrl.datapack.mappings.columns[key]
          var rankIdx
          if (rankId) {
            var key = `q_${questionId}_l_${loop}_c_${choice.id}_rank`
            rankIdx = ctrl.datapack.mappings.columns[key]
          }
          var matchChoice = function(row) {
            if (numericId !== false) {
              return row[idx] === numericId ? 1 : 0
            } else if (rankId) {
              return row[rankIdx] === rankId ? 1 : 0
            } else {
              return ~~row[idx]
            }
          }
          assignCellPercentTotal(
            ctrl.data.rows.items[matrix.length],
            matchChoice,
            matchViewBase
          )
          for (var filterItem of filterItems) {
            var matchAll = allChoiceIdxs
              ? function(row) {
                  if (!filterItem.filter.match(row)) return 0
                  return allChoiceIdxs.reduce(function(acc, i) {
                    return acc + ~~row[i]
                  }, 0)
                }
              : null
            var matchAnswered = function(row) {
              return matchViewBase(row) && filterItem.filter.match(row) ? 1 : 0
            }
            var cell = makeCell(
              function(row) {
                var filterMatch = filterItem.filter.match(row)
                if (!filterMatch) return 0
                return matchChoice(row)
              },
              matchAll,
              matchAnswered
            )
            cell.weight = choice.weight
            row.push(cell)
          }
          matrix.push(row)
        }
        ctrl.data.matrix = matrix
        processTotal()
        processCombinedWeighted(true)
        if (rows === 'filters') {
          flip()
        }
        finalize()
      }

      //
      // (filters x statements) + choice
      //

      if (tuple.includes('filters') && tuple.includes('statements')) {
        var filterItems = getActiveFilterItems()
        var statements = view.configs.statements.items.filter(function(
          statement
        ) {
          return statement.redact !== 'exclude'
        })
        var statementIds = statements.map(function(s) {
          return s.id
        })
        var choices = view.configs.choices.items
        var choiceId = view.slots.target
        var matrix = []
        ensureMergeCol(choices, statementIds)
        // rows
        {
          ctrl.data.rows = {
            type: 'filter',
            items: filterItems.map(function(filterItem, idx) {
              return {
                color: getStandardColor(idx),
                global: filterItem.global,
                value: filterItem.filter,
                count: 0,
                respondents: collectRespondents(function(row) {
                  return filterItem.filter.match(row)
                }),
              }
            }),
          }
        }
        // cols
        {
          ctrl.data.cols = {
            type: 'statement',
            items: statements.map(function(statement, statementIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(
                  choiceId ? { optionIds: [choiceId] } : null,
                  statement.id
                )
              } else {
                let idxs
                if (choiceId) {
                  let key
                  if (questionType === Question.Types.CONSTANT_SUM) {
                    key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choiceId}_number`
                  } else {
                    key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choiceId}_selected`
                  }
                  idxs = [ctrl.datapack.mappings.columns[key]]
                } else {
                  idxs = choices.map(function(choice) {
                    let key
                    if (questionType === Question.Types.CONSTANT_SUM) {
                      key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_number`
                    } else {
                      key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_selected`
                    }
                    return ctrl.datapack.mappings.columns[key]
                  })
                }
                matchBase = function(row) {
                  return _.some(idxs, function(idx) {
                    return ~~row[idx]
                  })
                }
              }
              return {
                color: getLinearColor(statementIdx, statements.length, true), // why reverse true?
                value: statement,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        // cells
        if (!view.shownBase) {
          ensureAnsweredCol(statementIds)
        }
        var statementCellPercentMatches = statements.map(function(
          statement,
          statementIdx
        ) {
          var key
          if (questionType === Question.Types.CONSTANT_SUM) {
            key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choiceId}_number`
          } else {
            key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choiceId}_selected`
          }
          var idx = ctrl.datapack.mappings.columns[key]
          var matchSelected = function(row) {
            return ~~row[idx]
          }
          var matchBase
          if (view.shownBase) {
            matchBase = makeShownMatcher(
              choiceId ? { optionIds: [choiceId] } : null,
              statement.id
            )
          } else {
            var answeredKey = `q_${questionId}_l_${loop}_s_${statement.id}_answered`
            var answeredIdx = ctrl.datapack.mappings.columns[answeredKey]
            matchBase = function(row) {
              return ~~row[answeredIdx] ? 1 : 0
            }
          }
          matchBase = subtractExcludedChoices(matchBase, statement.id)
          assignCellPercentTotal(
            ctrl.data.cols.items[statementIdx],
            matchSelected,
            matchBase
          )
          return { selected: matchSelected, base: matchBase }
        })
        for (var filterItem of filterItems) {
          var row = []
          for (
            let statementIdx = 0;
            statementIdx < statements.length;
            statementIdx++
          ) {
            var statement = statements[statementIdx]
            var matchAll = null
            if (questionType === Question.Types.CONSTANT_SUM) {
              var allChoiceIdxsForStatement = choices.map(function(ch) {
                var k = `q_${questionId}_l_${loop}_s_${statement.id}_c_${ch.id}_number`
                return ctrl.datapack.mappings.columns[k]
              })
              matchAll = function(row) {
                if (!filterItem.filter.match(row)) return 0
                return allChoiceIdxsForStatement.reduce(function(acc, i) {
                  return acc + ~~row[i]
                }, 0)
              }
            }

            var cellPercentMatches = statementCellPercentMatches[statementIdx]
            var matchStatementBase = cellPercentMatches.base
            var matchAnswered = function(row) {
              return matchStatementBase(row) && filterItem.filter.match(row)
                ? 1
                : 0
            }

            var cell = makeCell(
              function(row) {
                var filterMatch = filterItem.filter.match(row)
                if (!filterMatch) return 0
                return cellPercentMatches.selected(row)
              },
              matchAll,
              matchAnswered
            )
            cell.weight = 0
            row.push(cell)
          }
          matrix.push(row)
        }
        ctrl.data.matrix = matrix
        processTotal()
        if (rows === 'statements') {
          flip()
        }
        finalize()
      }

      //
      // (choices x statements)
      //

      if (tuple.includes('choices') && tuple.includes('statements')) {
        var choices = view.configs.choices.items.filter(function(choice) {
          return choice.redact !== 'exclude'
        })
        var statements = view.configs.statements.items.filter(function(
          statement
        ) {
          return statement.redact !== 'exclude'
        })
        var statementIds = statements.map(function(s) {
          return s.id
        })
        var matrix = []
        var linear = hasLinearChoiceColors(questionId)
        ensureMergeCol(choices, statementIds)
        if (!view.shownBase) {
          ensureAnsweredCol(statementIds)
        }
        // rows
        {
          ctrl.data.rows = {
            type: 'choice',
            items: choices.map(function(choice, choiceIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(choice, null)
              } else {
                var keys = statements.map(function(statement) {
                  if (questionType === Question.Types.CONSTANT_SUM) {
                    return `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_number`
                  } else {
                    return `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_selected`
                  }
                })
                var idxs = keys.map(function(key) {
                  return ctrl.datapack.mappings.columns[key]
                })
                matchBase = function(row) {
                  return _.some(idxs, function(idx) {
                    return ~~row[idx]
                  })
                }
              }
              return {
                color: linear ? getLinearColor(choiceIdx, choices.length) : getStandardColor(choiceIdx), // prettier-ignore
                value: choice,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        // cols
        {
          ctrl.data.cols = {
            type: 'statement',
            items: statements.map(function(statement, statementIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(null, statement.id)
              } else {
                var keys = choices.map(function(choice) {
                  if (questionType === Question.Types.CONSTANT_SUM) {
                    return `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_number`
                  } else {
                    return `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_selected`
                  }
                })
                var idxs = keys.map(function(key) {
                  return ctrl.datapack.mappings.columns[key]
                })
                matchBase = function(row) {
                  return _.some(idxs, function(idx) {
                    return ~~row[idx]
                  })
                }
              }
              return {
                color: getLinearColor(statementIdx, statements.length, true), // why reverse true?
                value: statement,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        for (var choice of choices) {
          var row = []
          for (var statement of statements) {
            var key
            if (questionType === Question.Types.CONSTANT_SUM) {
              key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_number`
            } else {
              key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_selected`
            }
            var idx = ctrl.datapack.mappings.columns[key]
            var matchAll = null
            if (questionType === Question.Types.CONSTANT_SUM) {
              var allChoiceIdxsForStatement = choices.map(function(ch) {
                var k = `q_${questionId}_l_${loop}_s_${statement.id}_c_${ch.id}_number`
                return ctrl.datapack.mappings.columns[k]
              })
              matchAll = function(row) {
                return allChoiceIdxsForStatement.reduce(function(acc, i) {
                  return acc + ~~row[i]
                }, 0)
              }
            }

            var matchAnswered
            if (view.shownBase) {
              matchAnswered = makeShownMatcher(null, statement.id)
            } else {
              var answeredKey = `q_${questionId}_l_${loop}_s_${statement.id}_answered`
              var answeredIdx = ctrl.datapack.mappings.columns[answeredKey]
              matchAnswered = function(row) {
                return ~~row[answeredIdx] ? 1 : 0
              }
            }
            matchAnswered = subtractExcludedChoices(matchAnswered, statement.id)

            var cell = makeCell(
              function(row) {
                return ~~row[idx]
              },
              matchAll,
              matchAnswered
            )
            cell.weight = choice.weight
            row.push(cell)
          }
          matrix.push(row)
        }
        ctrl.data.matrix = matrix
        processTotal()
        processCombinedWeighted(true)
        if (rows === 'statements') {
          flip()
        }
        finalize()
      }

      //
      // (choices x ranks)
      //

      if (tuple.includes('choices') && tuple.includes('ranks')) {
        var choices = view.configs.choices.items.filter(function(choice) {
          return choice.redact !== 'exclude'
        })
        var ranks = view.configs.ranks.items.filter(function(rank) {
          return rank.redact !== 'exclude'
        })
        var matrix = []
        ensureMergeCol(choices)
        // rows
        {
          var linear = hasLinearChoiceColors(questionId)
          ctrl.data.rows = {
            type: 'choice',
            items: choices.map(function(choice, choiceIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(choice, null)
              } else {
                var key = `q_${questionId}_l_${loop}_c_${choice.id}_selected`
                var rowIdx = ctrl.datapack.mappings.columns[key]
                matchBase = function(row) {
                  return ~~row[rowIdx]
                }
              }
              return {
                color: linear ? getLinearColor(choiceIdx, choices.length) : getStandardColor(choiceIdx), // prettier-ignore
                value: choice,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        // cols
        {
          ctrl.data.cols = {
            type: 'rank',
            items: ranks.map(function(rank, rankIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(null, null)
              } else {
                var keys = choices.map(function(choice) {
                  return `q_${questionId}_l_${loop}_c_${choice.id}_rank`
                })
                var idxs = keys.map(function(key) {
                  return ctrl.datapack.mappings.columns[key]
                })
                matchBase = function(row) {
                  return _.some(idxs, function(idx) {
                    return row[idx] === rank.id ? 1 : 0
                  })
                }
              }
              return {
                color: getStandardColor(rankIdx),
                value: rank,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        // cells
        var matchAnswered
        if (view.shownBase) {
          matchAnswered = makeShownMatcher(null, null)
        } else {
          var answeredKey = `q_${questionId}_l_${loop}_answered`
          var answeredIdx = ctrl.datapack.mappings.columns[answeredKey]
          matchAnswered = function(row) {
            return ~~row[answeredIdx] ? 1 : 0
          }
        }
        matchAnswered = subtractExcludedChoices(matchAnswered, null)
        for (var choice of choices) {
          var row = []
          for (var rank of ranks) {
            var key = `q_${questionId}_l_${loop}_c_${choice.id}_rank`
            var idx = ctrl.datapack.mappings.columns[key]
            var cell = makeCell(
              function(row) {
                return row[idx] === rank.id ? 1 : 0
              },
              null,
              matchAnswered
            )
            cell.weight = choice.weight
            row.push(cell)
          }
          matrix.push(row)
        }
        ctrl.data.matrix = matrix
        processTotal()
        processCombinedWeighted(true)
        if (rows === 'ranks') {
          flip()
        }
        finalize()
      }

      //
      // (filters x ranks) + choice
      //

      if (tuple.includes('filters') && tuple.includes('ranks')) {
        var filterItems = getActiveFilterItems()
        var ranks = view.configs.ranks.items.filter(function(rank) {
          return rank.redact !== 'exclude'
        })
        var choices = view.configs.choices.items
        var choiceId = view.slots.target
        var matrix = []
        ensureMergeCol(choices)
        // rows
        {
          ctrl.data.rows = {
            type: 'filter',
            items: filterItems.map(function(filterItem, idx) {
              return {
                color: getStandardColor(idx),
                global: filterItem.global,
                value: filterItem.filter,
                count: 0,
                respondents: collectRespondents(function(row) {
                  return filterItem.filter.match(row)
                }),
              }
            }),
          }
        }
        // cols
        {
          ctrl.data.cols = {
            type: 'rank',
            items: ranks.map(function(rank, rankIdx) {
              var matchBase
              if (view.shownBase) {
                matchBase = makeShownMatcher(choiceId ? { optionIds: [choiceId] } : null, null) // prettier-ignore
              } else {
                let idxs
                if (choiceId) {
                  const key = `q_${questionId}_l_${loop}_c_${choiceId}_rank`
                  idxs = [ctrl.datapack.mappings.columns[key]]
                } else {
                  idxs = choices.map(function(choice) {
                    const key = `q_${questionId}_l_${loop}_c_${choice.id}_rank`
                    return ctrl.datapack.mappings.columns[key]
                  })
                }
                matchBase = function(row) {
                  return _.some(idxs, function(idx) {
                    return row[idx] === rank.id ? 1 : 0
                  })
                }
              }
              return {
                color: getStandardColor(rankIdx),
                value: rank,
                count: 0,
                respondents: collectRespondents(matchBase),
              }
            }),
          }
        }
        // cells
        var matchViewBase
        if (view.shownBase) {
          matchViewBase = makeShownMatcher(
            choiceId ? { optionIds: [choiceId] } : null,
            null
          )
        } else {
          var answeredKey = `q_${questionId}_l_${loop}_answered`
          var answeredIdx = ctrl.datapack.mappings.columns[answeredKey]
          matchViewBase = function(row) {
            return ~~row[answeredIdx] ? 1 : 0
          }
        }
        matchViewBase = subtractExcludedChoices(matchViewBase, null)
        var rankCellPercentMatches = ranks.map(function(rank, rankIdx) {
          var key = `q_${questionId}_l_${loop}_c_${choiceId}_rank`
          var idx = ctrl.datapack.mappings.columns[key]
          var matchSelected = function(row) {
            return row[idx] === rank.id ? 1 : 0
          }
          assignCellPercentTotal(
            ctrl.data.cols.items[rankIdx],
            matchSelected,
            matchViewBase
          )
          return matchSelected
        })
        for (var filterItem of filterItems) {
          var row = []
          var matchAnswered = function(row) {
            return matchViewBase(row) && filterItem.filter.match(row) ? 1 : 0
          }
          for (let rankIdx = 0; rankIdx < ranks.length; rankIdx++) {
            var rank = ranks[rankIdx]
            var matchSelected = rankCellPercentMatches[rankIdx]
            var cell = makeCell(
              function(row) {
                return matchSelected(row) && filterItem.filter.match(row)
                  ? 1
                  : 0
              },
              null,
              matchAnswered
            )
            cell.weight = rank.weight
            row.push(cell)
          }
          matrix.push(row)
        }
        ctrl.data.matrix = matrix
        processTotal()
        if (rows === 'ranks') {
          flip()
        }
        finalize()
      }

      console.timeEnd('buildData')
    }

    function buildTable() {
      console.time('buildTable')

      var format = ctrl.view.slots.format
      var dp = ctrl.dashboard.decimalPlaces

      function getValue(cell) {
        if (format === 'count') {
          return (cell.count || 0).toFixed(dp)
        }
        if (format === 'sum') {
          return (cell.sum || 0).toFixed(dp)
        }
        if (format === 'average') {
          return (cell.average || 0).toFixed(dp)
        }
        if (format === 'average-incl') {
          return (cell.averageIncl || 0).toFixed(dp)
        }
        if (format === 'sum-percent') {
          return ((cell.sumPercent || 0) * 100).toFixed(dp) + '%'
        }
        if (format === 'cell-percent') {
          return ((cell.cellPercent || 0) * 100).toFixed(dp) + '%'
        }
        if (format === 'row-percent') {
          return (cell.rowPercent * 100).toFixed(dp) + '%'
        }
        if (format === 'col-percent') {
          return (cell.colPercent * 100).toFixed(dp) + '%'
        }
        if (format === 'total-percent') {
          return (cell.totalPercent * 100).toFixed(dp) + '%'
        }
      }

      function getCellPercentHint(cell) {
        if (format !== 'cell-percent' || !cell || cell.total == null)
          return null
        var percentDp = Math.max(dp + 2, 2)
        var percent = Number(((cell.cellPercent || 0) * 100).toFixed(percentDp))
        var count = (cell.count || 0).toFixed(dp)
        var base = (cell.total || 0).toFixed(dp)
        return `${percent}% · ${count} of ${base}`
      }

      // TODO: remove from everywhere, this is now a slot
      var absolute = ctrl.view.table.absolute

      var marginOfError = ctrl.dashboard.marginOfError
      var isMoeEnabled =
        marginOfError.enabled &&
        (!ctrl.isShared || !marginOfError.isHiddenFromShared)
      var isMoeColumn =
        (format === 'row-percent' || format === 'total-percent') && isMoeEnabled
      var isMoeRow =
        (format === 'col-percent' || format === 'total-percent') && isMoeEnabled

      var data = ctrl.data
      var rowType = data.rows.type
      var colType = data.cols.type
      var sigTest = ctrl.dashboard.significanceTest
      var isSigTestEnabled =
        sigTest.enabled && (!ctrl.isShared || !sigTest.isHiddenFromShared)
      var hasCellPercentColumnTotal =
        isSigTestEnabled && format === 'cell-percent' && colType === 'filter'
      var hasCellPercentRowTotal =
        isSigTestEnabled && format === 'cell-percent' && rowType === 'filter'
      ctrl.table = []

      var header = []
      header.push({ type: 'blank' })

      for (var item of data.cols.items) {
        switch (colType) {
          case 'filter':
            header.push({
              type: 'filter',
              color: item.color,
              globe: item.global,
              filter: item.value,
              ellipse: true,
            })
            break
          case 'choice':
          case 'statement':
          case 'rank':
            header.push({
              type: 'text',
              color: item.color,
              globe: item.global,
              text: item.value.label,
              ellipse: true,
            })
            break
        }
      }
      if (colType === 'filter') {
        header.push({ type: 'filteradd' })
      }
      header.push({ type: 'gap' })
      if (isMoeColumn) {
        header.push({ type: 'text', text: 'MoE (max)' })
      }
      header.push({
        type: 'text',
        text: `Total (${
          format === 'col-percent' || hasCellPercentColumnTotal ? '%' : 'n'
        })`,
        bg: true,
      })
      ctrl.table.push(header)

      for (let i = 0; i < data.rows.items.length; i++) {
        var item = data.rows.items[i]
        var row = []
        switch (rowType) {
          case 'filter':
            row.push({
              type: 'filter',
              // color: item.color,
              globe: item.global,
              filter: item.value,
            })
            break
          case 'choice':
          case 'statement':
          case 'rank':
            row.push({
              type: 'text',
              // color: item.color,
              text: item.value.label,
            })
            break
        }
        for (var cell of data.matrix[i] || []) {
          row.push({
            type: 'value',
            text: getValue(cell),
            hint: getCellPercentHint(cell),
            highlight: cell.highlight,
          })
        }
        if (colType === 'filter') {
          row.push({ type: 'filterblank' }) // + column
        }
        row.push({ type: 'gap' })
        if (isMoeColumn) {
          if (format === 'row-percent') {
            row.push({
              type: 'value',
              text: marginOfError.get(item.count),
              prefix: marginOfError.TableValuePrefix,
            })
          }
          if (format === 'total-percent') {
            row.push({ type: 'blank' })
          }
        }
        row.push({
          type: 'value',
          // text: `${item.count} (${((item.count / data.count) * 100).toFixed(0)}%)`, // prettier-ignore
          text: hasCellPercentColumnTotal
            ? getValue(item.cellPercentTotal || {})
            : format === 'col-percent'
            ? (item.percent * 100).toFixed(dp) + '%'
            : item.count.toFixed(dp),
          hint: hasCellPercentColumnTotal
            ? getCellPercentHint(item.cellPercentTotal)
            : null,
          bg: true,
          highlight: item.highlight,
        })
        ctrl.table.push(row)
      }
      if (rowType === 'filter') {
        var row = [{ type: 'filteradd' }]
        for (var item of data.cols.items) {
          row.push({ type: 'filterblank' })
        }
        row.push({ type: 'gap' })
        if (isMoeColumn) {
          row.push({ type: 'blank', bg: false })
        }
        row.push({ type: 'blank', bg: true })
        ctrl.table.push(row)
      }
      var moeRow = []
      var footer = []
      moeRow.push({ type: 'text', text: 'MoE (max)' })
      footer.push({
        type: 'text',
        text: `Total (${
          format === 'row-percent' || hasCellPercentRowTotal ? '%' : 'n'
        })`,
        bg: true,
      })
      for (var item of data.cols.items) {
        if (format === 'col-percent') {
          moeRow.push({
            type: 'value',
            text: marginOfError.get(item.count),
            prefix: marginOfError.TableValuePrefix,
          })
        }
        if (format === 'total-percent') {
          moeRow.push({ type: 'blank' })
        }
        footer.push({
          type: 'value',
          // text: `${item.count} (${((item.count / data.count) * 100).toFixed(0)}%)`, // prettier-ignore
          text: hasCellPercentRowTotal
            ? getValue(item.cellPercentTotal || {})
            : format === 'row-percent'
            ? (item.percent * 100).toFixed(dp) + '%'
            : item.count.toFixed(dp),
          hint: hasCellPercentRowTotal
            ? getCellPercentHint(item.cellPercentTotal)
            : null,
          bg: true,
          highlight: item.highlight,
        })
      }
      if (colType === 'filter') {
        moeRow.push({ type: 'filterblank' }) // + column
        footer.push({ type: 'filterblank', bg: true }) // + column
      }
      moeRow.push({ type: 'gap' })
      footer.push({ type: 'gap', bg: true })
      if (isMoeColumn) {
        moeRow.push({ type: 'blank' }) // + column
        footer.push({
          type: 'value',
          text: marginOfError.get(ctrl.data.count),
          prefix: marginOfError.TableValuePrefix,
          bg: true,
          bold: true,
        })
      }
      moeRow.push({
        type: 'value',
        text: marginOfError.get(ctrl.data.count),
        prefix: marginOfError.TableValuePrefix,
        bg: true,
        bold: true,
      })
      footer.push({
        type: 'value',
        text: ctrl.data.count.toFixed(dp),
        bg: true,
        bold: true,
      })
      // if (rowType === 'filter') {
      //   footer.push({ type: 'blank' })
      // }
      if (isMoeRow) {
        ctrl.table.push(moeRow)
      }
      ctrl.table.push(footer)

      console.timeEnd('buildTable')
    }

    function getClipboardCellText(cell, rowIndex, columnIndex) {
      if (cell.type === 'blank') {
        return rowIndex === 0 && columnIndex === 0 ? ctrl.view.label : ''
      }
      if (cell.type === 'filter') {
        return cell.filter.name
      }
      if (cell.type === 'text') {
        return cell.text
      }
      if (cell.type === 'value') {
        return (cell.prefix || '') + cell.text
      }
      return null
    }

    function getTableExportRows() {
      if (!hasTable(ctrl.view) || !ctrl.table) return []

      return ctrl.table.reduce(function(rows, tableRow, rowIndex) {
        if (!tableRow.length || tableRow[0].type === 'filteradd') {
          return rows
        }

        var row = []
        tableRow.forEach(function(cell, columnIndex) {
          var text = getClipboardCellText(cell, rowIndex, columnIndex)
          if (text !== null) {
            row.push(text)
          }
        })
        rows.push(row)
        return rows
      }, [])
    }

    function escapeClipboardHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    }

    function getTableClipboardData() {
      var rows = getTableExportRows()
      return {
        html:
          '<table><tbody>' +
          rows
            .map(function(row) {
              return (
                '<tr>' +
                row
                  .map(function(cell) {
                    return '<td>' + escapeClipboardHtml(cell) + '</td>'
                  })
                  .join('') +
                '</tr>'
              )
            })
            .join('') +
          '</tbody></table>',
        text: rows
          .map(function(row) {
            return row.join('\t')
          })
          .join('\r\n'),
      }
    }

    function copyRichTableToClipboard(data) {
      var clipboard = $window.navigator && $window.navigator.clipboard
      var ClipboardItem = $window.ClipboardItem

      if (!clipboard || !clipboard.write || !ClipboardItem) {
        return $q.reject(new Error('Rich clipboard API unavailable'))
      }

      return clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([data.text], { type: 'text/plain' }),
          'text/html': new Blob([data.html], { type: 'text/html' }),
        }),
      ])
    }

    function copyTableToClipboard() {
      var data = getTableClipboardData()
      copyRichTableToClipboard(data)
        .then(function() {
          glToast.show('Table copied to clipboard!')
        })
        .catch(function() {
          clipboardService.copy(data.text, {
            toastMessage: 'Table copied to clipboard!',
          })
        })
    }

    function onCanvasInit() {
      if (ctrl.buildChartPending) {
        ctrl.buildChartPending = false
        buildChart()
      }
    }

    function getChartConfig(type, rotate, absolute) {
      function wrapLabel(label) {
        const maxCharsPerLine = isMobile() ? 22 : 30
        const maxLines = isMobile() ? 1 : 2
        const words = label.split(' ')
        if (!words.length) {
          return ['']
        }
        const lines = []
        let currentLine = ''
        words.forEach(word => {
          const nextLine = currentLine ? `${currentLine} ${word}` : word
          if (nextLine.length <= maxCharsPerLine) {
            currentLine = nextLine
            return
          }
          if (currentLine) {
            lines.push(currentLine)
          }
          if (word.length > maxCharsPerLine) {
            lines.push(word)
            currentLine = ''
          } else {
            currentLine = word
          }
        })
        if (currentLine) {
          lines.push(currentLine)
        }
        if (maxLines && lines.length > maxLines) {
          lines.splice(maxLines)
          lines[lines.length - 1] = _.last(lines).slice(0, -2) + '..'
        }
        return lines
      }

      function wrapScaleLabel(value) {
        var label = this.getLabelForValue(value)
        return wrapLabel(label)
      }

      function percentTick(val) {
        return absolute ? val : val + '%'
      }

      const getTooltipValue = prop => ctx => ctx.parsed[prop]

      const stacked = [
        ChartTypes.STACKED_BAR,
        ChartTypes.STACKED_AREA,
      ].includes(type)

      const categoryAxis = rotate ? 'y' : 'x'
      const valueAxis = rotate ? 'x' : 'y'
      const indexAxis = rotate ? 'y' : 'x'
      const tooltipAxis = rotate ? 'x' : 'y'

      var barConfig = {
        type: 'bar',
        indexAxis,
        scales: {
          [categoryAxis]: {
            stacked,
            grid: { display: false },
            ticks: { callback: wrapScaleLabel },
          },
          [valueAxis]: {
            beginAtZero: true,
            min: absolute ? undefined : 0,
            max: undefined,
            stacked,
            grid: { display: true },
            ticks: {
              precision: 0,
              callback: percentTick,
            },
          },
        },
        tooltip: {
          intersect: undefined,
          getValue: getTooltipValue(tooltipAxis),
        },
        datalabels: {
          anchor: 'end',
          align: 'start',
          color: 'white',
          clip: true,
        },
      }

      var lineConfig = {
        type: 'line',
        indexAxis,
        scales: {
          [categoryAxis]: {
            beginAtZero: false,
            offset: true,
            grid: { display: false },
            ticks: { callback: wrapScaleLabel },
          },
          [valueAxis]: {
            beginAtZero: true,
            min: absolute ? undefined : 0,
            stacked,
            ticks: {
              precision: 0,
              callback: percentTick,
            },
          },
        },
        tooltip: {
          intersect: false,
          getValue: getTooltipValue(tooltipAxis),
        },
        datalabels: {
          anchor: 'start',
          align: 'bottom',
          color: 'rgba(102, 102, 102, 1)',
          clip: false,
        },
      }

      var radarConfig = {
        type: 'radar',
        indexAxis: undefined,
        scales: {
          r: {
            beginAtZero: true,
            min: absolute ? undefined : 0,
            ticks: {
              precision: 0,
              callback: percentTick,
            },
            pointLabels: { padding: 20, callback: wrapLabel },
            grid: { circular: true },
          },
        },
        tooltip: {
          intersect: true,
          getValue: getTooltipValue('r'),
        },
        datalabels: {
          anchor: 'bottom',
          align: 'end',
          color: 'rgba(102, 102, 102, 1)',
          clip: false,
        },
      }

      var pieConfig = {
        type: 'pie',
        indexAxis: undefined,
        scales: {},
        tooltip: {
          intersect: true,
          getValue: function(ctx) {
            return ctx.parsed
          },
        },
        datalabels: {
          anchor: 'center',
          align: 'center',
          color: 'white',
          clip: false,
        },
      }

      switch (type) {
        case ChartTypes.STACKED_BAR:
          return _.merge({}, barConfig, {
            stacked,
            dataset: { backgroundOpacity: 1, fill: false },
          })
        case ChartTypes.GROUPED_BAR:
          return _.merge({}, barConfig, {
            stacked,
            dataset: { backgroundOpacity: 1, fill: true },
          })
        case ChartTypes.LINE:
          return _.merge({}, lineConfig, {
            stacked,
            dataset: { backgroundOpacity: 1, fill: false },
          })
        case ChartTypes.STACKED_AREA:
          return _.merge({}, lineConfig, {
            stacked,
            dataset: { backgroundOpacity: 0.5, fill: true },
          })
        case ChartTypes.SPIDER:
          return _.merge({}, radarConfig, {
            stacked,
            dataset: { backgroundOpacity: 0.5, fill: true },
          })
        case ChartTypes.PIE:
          return _.merge({}, pieConfig, {
            stacked: false,
            dataset: { backgroundOpacity: 1, fill: false },
          })
        default:
          return undefined
      }
    }

    function buildChart() {
      $timeout(function() {
        var container = document.getElementsByClassName('survey-explorer__chart-main')[0] // prettier-ignore
        var elem = document.getElementById('chart')
        if (!elem) {
          ctrl.buildChartPending = true
          return
        }
        var ctx = elem.getContext('2d')
        var data = ctrl.data

        var format = ctrl.view.slots.format
        var type = ctrl.view.chart.type
        var rotate = isChartRotatable(type) ? ctrl.view.chart.rotate : false

        // TODO: remove, now using format
        // var absolute = ctrl.view.chart.absolute
        var absolute =
          format === 'count' ||
          format === 'sum' ||
          format === 'average' ||
          format === 'average-incl'

        const dp = ctrl.dashboard.decimalPlaces
        const chartConfig = getChartConfig(type, rotate, absolute)

        function getValue(cell) {
          if (format === 'count') {
            return cell.count
          }
          if (format === 'sum') {
            return cell.sum
          }
          if (format === 'average') {
            return cell.average
          }
          if (format === 'average-incl') {
            return cell.averageIncl
          }
          if (format === 'sum-percent') {
            return (cell.sumPercent || 0) * 100
          }
          if (format === 'cell-percent') {
            return (cell.cellPercent || 0) * 100
          }
          if (format === 'row-percent') {
            return cell.rowPercent * 100
          }
          if (format === 'col-percent') {
            return cell.colPercent * 100
          }
          if (format === 'total-percent') {
            return cell.totalPercent * 100
          }
        }

        function getFixedValue(value) {
          return value.toFixed(dp)
        }

        // labels
        var labels = []

        // datasets
        var datasets = []

        var isPie = type === ChartTypes.PIE
        var labelSource = isPie ? data.cols : data.rows
        var datasetSource = isPie ? data.rows : data.cols

        for (var item of labelSource.items) {
          switch (labelSource.type) {
            case 'filter':
              labels.push(item.value.name)
              break
            case 'choice':
            case 'statement':
            case 'rank':
              labels.push(item.value.label)
              break
          }
        }
        for (let i = 0; i < datasetSource.items.length; i++) {
          var item = datasetSource.items[i]
          var dataset = {
            label: null,
            data: [],
            backgroundColor: isPie
              ? labelSource.items.map(function(labelItem) {
                  return colors.rgba(
                    labelItem.color,
                    chartConfig.dataset.backgroundOpacity
                  )
                })
              : colors.rgba(item.color, chartConfig.dataset.backgroundOpacity),
            highlights: [],
            fill: chartConfig.dataset.fill,
            borderColor: isPie ? 'white' : item.color,
          }
          switch (datasetSource.type) {
            case 'filter':
              dataset.label = item.value.name
              break
            case 'choice':
            case 'statement':
            case 'rank':
              dataset.label = item.value.label
              break
          }
          var innerCount = isPie ? labelSource.items.length : data.matrix.length
          for (let k = 0; k < innerCount; k++) {
            var cell = isPie ? data.matrix[i][k] : data.matrix[k][i]
            dataset.data.push(getValue(cell))
            dataset.highlights.push(cell.highlight)
            // dataset.data.push(absolute ? cell.count : cell.ratio * 100)
            // dataset.backgroundColor.push(data.rows.items[k].color)
          }
          datasets.push(dataset)
        }

        // var barPercentage = stacked ? 0.7 : 0.9
        // var categoryPercentage = 1
        var barPercentage = 0.9
        var categoryPercentage = 0.9

        var config = {
          type: chartConfig.type,
          data: {
            labels: labels,
            datasets: datasets,
          },
          plugins: [
            window.ChartDataLabels,
            {
              id: 'legendGap',
              beforeInit(chart) {
                const legend = chart.legend
                const originalFit = legend.fit
                legend.fit = function() {
                  originalFit.call(this)
                  this.height += 10 // add 10px padding between legend and chart
                }
              },
            },
          ],
          options: {
            responsive: true,
            maintainAspectRatio: false,
            borderRadius: 4,
            barPercentage: barPercentage,
            categoryPercentage: categoryPercentage,
            // maxBarThickness: 60,
            indexAxis: chartConfig.indexAxis,
            scales: chartConfig.scales,
            plugins: {
              legend: {
                display: false,
                display: true,
                position: 'top',
                align: 'start',
                labels: {
                  boxWidth: 10,
                  boxHeight: 10,
                  usePointStyle: true,
                  pointStyle: 'circle',
                },
              },
              tooltip: {
                position: 'average',
                mode: 'index',
                intersect: chartConfig.tooltip.intersect,
                callbacks: {
                  // title: function(ctx) {
                  //   var datasetIndex = ctx[0].datasetIndex
                  //   var dataIndex = ctx[0].dataIndex
                  //   return sets[datasetIndex].aspects[dataIndex].label
                  // },
                  label: function(ctx) {
                    var value = chartConfig.tooltip.getValue(ctx)
                    if (!value) {
                      return ''
                    }
                    value = getFixedValue(value)
                    var prefix = ''
                    var suffix = ''
                    prefix = ctx.dataset.label + ': '
                    if (absolute) {
                      // var percent = data.matrix[ctx.dataIndex][ctx.datasetIndex].ratio * 100 // prettier-ignore
                      // suffix += ` (${percent}%)`
                    } else {
                      suffix += '%'
                      // var total = data.matrix[ctx.dataIndex][ctx.datasetIndex].count // prettier-ignore
                      // suffix += ` (${total})`
                    }
                    var highlight = ctx.dataset.highlights[ctx.dataIndex]
                    if (highlight === 'green') {
                      suffix += ' \u2B06 ' // ⬆ up arrow symbol
                    }
                    if (highlight === 'red') {
                      suffix += ' \u2B07 ' // ⬇ down arrow symbol
                    }
                    return prefix + value + suffix
                  },
                },
              },
              datalabels: {
                anchor: chartConfig.datalabels.anchor,
                align: chartConfig.datalabels.align,
                offset: 10,
                color: chartConfig.datalabels.color,
                font: {
                  family: 'Roboto, sans-serif',
                  weight: '500',
                  lineHeight: 0,
                },
                clip: chartConfig.datalabels.clip,
                formatter: function(value, ctx) {
                  if (!value) {
                    return ''
                  }
                  if (absolute) {
                    return getFixedValue(value)
                  }
                  return getFixedValue(value) + '%'
                },
                display: function(ctx) {
                  var chartSize = rotate ? ctx.chart.height : ctx.chart.width
                  chartSize -= 60 // subtract gutter/axis size
                  var numLabels = chartConfig.stacked ? data.matrix.length : data.matrix.length * data.matrix[0].length // prettier-ignore
                  var labelSize = rotate ? 20 : 50
                  var totalSize = labelSize * numLabels
                  // console.log('chartSize', chartSize)
                  // console.log('numLabels', numLabels)
                  // console.log('totalSize', totalSize) // prettier-ignore
                  if (totalSize > chartSize) return false
                  return true
                },
              },
            },
          },
        }

        // var idealBarSize = rotate ? 34 : 80

        // var size = config.data.datasets.length * config.data.labels.length
        var idealBarSize = rotate ? 34 : 80
        var barsPerCategory =
          type === ChartTypes.STACKED_BAR ? 1 : config.data.datasets.length
        var numCategories = config.data.labels.length
        var categorySize = (idealBarSize * barsPerCategory) / barPercentage
        var sampleSize = (categorySize * numCategories) / categoryPercentage
        var axisSize = rotate ? 34 : 45 // estimated gutter?
        if ([ChartTypes.SPIDER, ChartTypes.PIE].includes(type)) {
          container.style.flexBasis = '400px'
          container.style.maxWidth = 'unset'
        } else if (rotate) {
          // define the chart height to match the target bar size
          container.style.flexBasis = axisSize + sampleSize + 'px'
          container.style.maxWidth = '9999px'
        } else {
          container.style.maxWidth = axisSize + sampleSize + 'px'
          container.style.flexBasis = '400px'
        }

        console.log({ type, rotate })

        console.log('chart', _.cloneDeep(config))

        if (ctrl.chart) {
          ctrl.chart.destroy()
        }
        ctrl.chart = new Chart(ctx, config)

        // container.style.maxWidth = '100px'

        // ctrl.chartRebuild = true

        // if (ctrl.chartRebuild) {
        //   if (ctrl.chart) {
        //     ctrl.chart.destroy()
        //     ctrl.chart = null
        //   }
        //   ctrl.chartRebuild = false
        // }

        // if (!ctrl.chart) {
        //   ctrl.chart = new Chart(ctx, config)
        // } else {
        //   var chart = ctrl.chart
        //   chart.data.labels = config.data.labels
        //   _.each(config.data.datasets, function(dataset, idx) {
        //     if (!chart.data.datasets[idx]) {
        //       chart.data.datasets[idx] = {}
        //     }
        //     chart.data.datasets[idx].label = dataset.label
        //     chart.data.datasets[idx].data = dataset.data
        //     chart.data.datasets[idx].backgroundColor = dataset.backgroundColor // prettier-ignore
        //   })
        //   chart.options.indexAxis = config.options.indexAxis
        //   _.each(['x', 'y'], function(axis) {
        //     var op = axis === 'y' ? y : x
        //     var scale = chart.options.scales[axis]
        //     scale.stacked = op.stacked
        //     scale.grid.display = op.grid.display
        //     scale.ticks.callback = op.ticks.callback
        //   })

        //   chart.update()
        //   // chart.resize()
        // }
      }, 10)
    }

    function buildCloud() {
      ctrl.cloud = {
        sentences: _(ctrl.list.items)
          .map(function(item) {
            return item.text.split(' | ')
          })
          .flatten()
          .value(),
      }
    }

    function isSlot(slot) {
      if (slot === 'loop') {
        return ctrl.view.loops.length
      }
      if (slot === 'statements') return ctrl.view.statements.length
      if (slot === 'choices') return true
      if (slot === 'ranks') return ctrl.view.ranks.length
      if (slot === 'filters') return true
      if (slot === 'format') {
        return true
      }
      if (slot === 'sort') {
        return hasTable(ctrl.view)
      }
    }

    function isVariableSlot(slot) {
      return ['statements', 'choices', 'ranks', 'filters'].indexOf(slot) !== -1
    }

    function getSlotOptions(slot) {
      if (slot === 'loop') return ctrl.slotOptions.loop
      if (isVariableSlot(slot)) return ctrl.slotOptions[slot]
      if (slot === 'format') return ctrl.slotOptions.format
      if (slot === 'sort') return ctrl.slotOptions.sort
    }

    function getSlotValue(slot) {
      if (slot === 'loop') return ctrl.view.slots.loop
      if (isVariableSlot(slot)) {
        return surveyExplorerSlotsService.getValue(
          ctrl.view.slots,
          slot,
          ctrl.slotModel.pinnedCategory
        )
      }
      if (slot === 'format') return ctrl.view.slots.format
      if (slot === 'sort') return ctrl.view.slots.sort || 'manual'
    }

    function setSlotValue(slot, id) {
      var view = ctrl.view
      if (slot === 'loop') {
        view.slots.loop = id
      }
      if (isVariableSlot(slot)) {
        var next = surveyExplorerSlotsService.setValue(
          view.slots,
          slot,
          id,
          ctrl.slotModel.pinnedCategory,
          ctrl.slotModel.items
        )
        view.slots.rows = next.rows
        view.slots.columns = next.columns
        view.slots.target = next.target
      }
      if (slot === 'format') {
        view.slots.format = id
      }
      if (slot === 'sort') {
        view.slots.sort = id
      }
      build()
    }

    function toggleShownBase() {
      ctrl.view.shownBase = !ctrl.view.shownBase
      build()
    }

    function isSlotConfig(slot) {
      if (slot === 'loop') return ctrl.view.loops.length
      if (slot === 'statements') return ctrl.view.statements.length
      if (slot === 'choices') return true
      if (slot === 'ranks') return ctrl.view.ranks.length
      if (slot === 'filters') return true
      return false
    }

    function editSlotConfig(slot) {
      if (slot === 'loop') return editMods('loops')
      if (slot === 'statements') return editMods('statements')
      if (slot === 'choices') return editMods('choices')
      if (slot === 'ranks') return editMods('ranks')
      if (slot === 'filters') return manageViewFilters()
    }

    function editMods(type) {
      var view = ctrl.view
      var config = view.configs[type]
      var options = view[type]
      var isRank = [Question.Types.RANK].includes(view.questionType)
      var full = type === 'choices' && !isRank
      var prevIds = config.items.map(function(it) {
        return it.id
      })
      showModsDialog(config, options, full).then(function(config) {
        var newIds = config.items.map(function(it) {
          return it.id
        })
        if (!_.isEqual(prevIds, newIds)) {
          view.slots.sort = 'manual'
        }
        view.configs[type] = config
        build()
      })
    }

    function showFilterDialog(filters) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-filter-dialog__dialog">',
          '<survey-explorer-filter-dialog ',
            'channels="channels"',
            'datapack="datapack"',
            'dashboard="dashboard"',
            'filters="filters"',
            'on-done="dialog.close($filters)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          channels: ctrl.channels,
          datapack: ctrl.datapack,
          dashboard: ctrl.dashboard,
          filters: _.isArray(filters) ? filters : [],
        },
      }
      return glDialog.show(options)
    }

    function getAllPrefilters(excludePrivate) {
      var global = ctrl.dashboard.prefilters.map(id => ctrl.filtersById[id])
      if (isSectionView(ctrl.view)) {
        return excludePrivate
          ? global.filter(function(filter) {
              return !filter.private
            })
          : global
      }
      var local = ctrl.view.prefilters.map(id => ctrl.filtersById[id])
      local = local.filter(f => !global.includes(f)) // remove dupes in local
      var result = global.concat(local)
      if (excludePrivate) {
        result = result.filter(function(filter) {
          return !filter.private
        })
      }
      return result
    }

    function isGlobalPrefilter(filter) {
      return ctrl.dashboard.prefilters.includes(filter.id)
    }

    function isLocalPrefilter(filter) {
      return ctrl.view.prefilters.includes(filter.id)
    }

    function createFilter() {
      return showFilterDialog(null).then(function(filters) {
        var filter = filters[0]
        ctrl.dashboard.filters.push(filter)
        ctrl.filtersById[filter.id] = filter
        filter.match = filter.toDatapackMatcher(ctrl.datapack)
        return filter
      })
    }

    function importFilters() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-import-filters-dialog__dialog">',
          '<survey-explorer-import-filters-dialog ',
            'survey="survey" ',
            'dashboards="dashboards" ',
            'on-done="dialog.close($filters)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          survey: ctrl.survey,
          dashboards: ctrl.dashboards.filter(function(dashboard) {
            return dashboard.id !== ctrl.dashboard.id
          }),
        },
      }
      return glDialog.show(options).then(function(filters) {
        for (const filter of filters) {
          var newFilter = filter.clone().refresh()
          ctrl.dashboard.filters.push(newFilter)
          ctrl.filtersById[newFilter.id] = newFilter
          newFilter.match = newFilter.toDatapackMatcher(ctrl.datapack)
        }
        updateRestricted()
        build()
      })
    }

    function editFilters(event, filters) {
      if (event && event.defaultPrevented) return

      // remove restricted filters
      _.remove(filters, function(filter) {
        return ctrl.isShared && filter.restricted
      })

      if (!filters.length) return

      showFilterDialog(filters).then(function(nextFilters) {
        nextFilters.forEach(function(nextFilter) {
          var filter = _.find(filters, { id: nextFilter.id })
          filter.deserialize(nextFilter.serialize())
          filter.match = filter.toDatapackMatcher(ctrl.datapack)
        })
        build()
      })
    }

    function duplicateFilters(filters) {
      _.each(filters, function(filter) {
        if (ctrl.isShared && filter.restricted) return
        var idx = ctrl.dashboard.filters.indexOf(filter)
        var newFilter = filter.duplicate()
        ctrl.dashboard.filters.splice(idx + 1, 0, newFilter)
        ctrl.filtersById[newFilter.id] = newFilter
        newFilter.match = newFilter.toDatapackMatcher(ctrl.datapack)
        setSelected(newFilter, true)
        setSelected(filter, false)
      })
    }

    function togglePrivateFilters(filters, isPrivate) {
      filters.forEach(function(filter) {
        filter.private = isPrivate
      })
    }

    function deleteFilters(filters) {
      var allFilters = ctrl.dashboard.filters
      filters.forEach(function(filter) {
        // remove from global prefilters
        var idx = ctrl.dashboard.prefilters.indexOf(filter.id)
        if (idx !== -1) {
          ctrl.dashboard.prefilters.splice(idx, 1)
        }
        for (var view of ctrl.dashboard.views) {
          // remove from view prefilters
          idx = view.prefilters.indexOf(filter.id)
          if (idx !== -1) {
            view.prefilters.splice(idx, 1)
          }
          // remove from view crossfilters
          idx = view.configs.filters.items.indexOf(filter.id)
          if (idx !== -1) {
            view.configs.filters.items.splice(idx, 1)
          }
        }
        // remove from weight scheme
        removeWeightRuleFilter(filter)
        // remove from filters registry
        idx = allFilters.indexOf(filter)
        allFilters.splice(idx, 1)
        delete ctrl.filtersById[filter.id]
      })
      build()
    }

    function onRemoveFilter($event, isGlobal, filter, context) {
      if ($event && $event.shiftKey) {
        removeFilterFromAllViews(filter, context)
        return false
      }
      if (!isGlobal && getCurrentAndSelectedViews().length > 1) {
        // show dropdown menu
        return true
      }
      removeFilterByContext(filter, false, context)
      return false
    }

    function removeFilterByContext(filter, fromSelected, context) {
      if (context === 'prefilter') {
        removePrefilter(filter, fromSelected)
      }
      if (context === 'crossfilter') {
        removeViewFilter(filter, fromSelected)
      }
    }

    function removeFilterFromAllViews(filter, context) {
      var filterId = filter.id
      var accessor
      if (context === 'prefilter') {
        var pIdx = ctrl.dashboard.prefilters.indexOf(filterId)
        if (pIdx !== -1) ctrl.dashboard.prefilters.splice(pIdx, 1)
        accessor = function(v) {
          return v.prefilters
        }
      } else {
        accessor = function(v) {
          return v.configs.filters.items
        }
      }
      ctrl.dashboard.views.forEach(function(view) {
        var arr = accessor(view)
        var i = arr.indexOf(filterId)
        if (i !== -1) arr.splice(i, 1)
      })
      build()
    }

    function removeFilterFromCollections(
      filterId,
      fromSelected,
      dashboardArray,
      viewArrayAccessor
    ) {
      const idx = dashboardArray.indexOf(filterId)
      if (idx !== -1) {
        dashboardArray.splice(idx, 1)
      }
      const targetViews = fromSelected
        ? getCurrentAndSelectedViews()
        : [ctrl.view]
      targetViews.forEach(view => {
        const arr = viewArrayAccessor(view)
        const idx = arr.indexOf(filterId)
        if (idx !== -1) {
          arr.splice(idx, 1)
        }
      })
    }

    function removePrefilter(filter, fromSelected) {
      removeFilterFromCollections(
        filter.id,
        fromSelected,
        ctrl.dashboard.prefilters,
        view => view.prefilters
      )
      build()
    }

    function removeViewFilter(filter, fromSelected) {
      removeFilterFromCollections(
        filter.id,
        fromSelected,
        [],
        view => view.configs.filters.items
      )
      build()
    }

    function removeWeightRuleFilter(filter) {
      ctrl.dashboard.weightScheme.removeWeightRulesByFilterId(filter.id)
      applyWeightScheme()
    }

    function showFiltersDialog(opts) {
      var title = opts.title
      var hiddenIds = opts.hiddenIds
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-filters-dialog__dialog">',
          '<survey-explorer-filters-dialog ',
            'title="title"',
            'dashboard="dashboard"',
            'view="view"',
            'hidden-ids="hiddenIds"',
            'selected-views-count="selectedViewsCount"',
            'is-shared="isShared"',
            'create-filter="createFilter()"',
            'on-done="dialog.close($result)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          title: title,
          dashboard: ctrl.dashboard,
          view: ctrl.view,
          hiddenIds: hiddenIds,
          selectedViewsCount:
            opts.selectedViewsCount !== undefined
              ? opts.selectedViewsCount
              : getCurrentAndSelectedViews().length,
          isShared: ctrl.isShared,
          createFilter: createFilter,
        },
      }
      return glDialog.show(options)
    }

    function applyFiltersToCollections(
      filters,
      global,
      toSelected,
      dashboardArray,
      viewArrayAccessor
    ) {
      function removeId(arr, value) {
        const idx = arr.indexOf(value)
        if (idx !== -1) {
          arr.splice(idx, 1)
        }
      }
      function addId(arr, value) {
        const idx = arr.indexOf(value)
        if (idx === -1) {
          arr.push(value)
        }
      }
      const targetViews = toSelected
        ? getCurrentAndSelectedViews()
        : [ctrl.view]
      for (var filter of filters) {
        const filterId = filter.id
        if (global) {
          ctrl.dashboard.views.forEach(view => {
            removeId(viewArrayAccessor(view), filterId)
          })
          addId(dashboardArray, filterId)
        } else {
          removeId(dashboardArray, filterId)
          targetViews.forEach(view => {
            if (isSectionView(view)) return
            addId(viewArrayAccessor(view), filterId)
          })
        }
      }
    }

    function addPrefilters() {
      if (isSectionView(ctrl.view)) return
      var hiddenIds = ctrl.dashboard.prefilters.concat(ctrl.view.prefilters)
      showFiltersDialog({ title: 'Add Prefilters', hiddenIds: hiddenIds }).then(
        function(result) {
          var filters = result.filters
          var global = result.global
          var toSelected = result.toSelected
          applyFiltersToCollections(
            filters,
            global,
            toSelected,
            ctrl.dashboard.prefilters,
            view => view.prefilters
          )
          build()
        }
      )
    }

    function addViewFilters() {
      if (isSectionView(ctrl.view)) return
      var hiddenIds = ctrl.view.configs.filters.items.slice()
      showFiltersDialog({
        title: 'Add Filters',
        hiddenIds: hiddenIds,
      }).then(function(result) {
        var targetViews
        if (result.global) {
          targetViews = ctrl.dashboard.views
        } else if (result.toSelected) {
          targetViews = getCurrentAndSelectedViews()
        } else {
          targetViews = [ctrl.view]
        }
        result.filters.forEach(function(filter) {
          targetViews.forEach(function(view) {
            if (!view.configs.filters.items.includes(filter.id)) {
              view.configs.filters.items.push(filter.id)
            }
          })
        })
        build()
      })
    }

    function showManageFiltersDialog(items) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-manage-filters-dialog__dialog">',
          '<survey-explorer-manage-filters-dialog ',
            'items="items"',
            'on-add="onAdd($hiddenIds)" ',
            'on-create="onCreate()" ',
            'on-done="dialog.close($items)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          items: items,
          onCreate: function() {
            return createFilter()
          },
          onAdd: function(hiddenIds) {
            return showFiltersDialog({
              title: 'Add Filters',
              hiddenIds: hiddenIds,
            }).then(function(result) {
              var otherViews
              if (result.global) {
                otherViews = ctrl.dashboard.views.filter(function(v) {
                  return v !== ctrl.view
                })
              } else if (result.toSelected) {
                otherViews = getCurrentAndSelectedViews().filter(function(v) {
                  return v !== ctrl.view
                })
              }
              if (otherViews) {
                result.filters.forEach(function(filter) {
                  otherViews.forEach(function(view) {
                    if (!view.configs.filters.items.includes(filter.id)) {
                      view.configs.filters.items.push(filter.id)
                    }
                  })
                })
              }
              return result
            })
          },
        },
      })
    }

    function manageViewFilters() {
      var prevIds = ctrl.view.configs.filters.items.slice()
      var items = prevIds.map(function(id) {
        return { filter: ctrl.filtersById[id] }
      })
      showManageFiltersDialog(items).then(function(items) {
        var newIds = items.map(function(item) {
          return item.filter.id
        })
        if (!_.isEqual(prevIds, newIds)) {
          ctrl.view.slots.sort = 'manual'
        }
        ctrl.view.configs.filters.items.length = 0
        newIds.forEach(function(id) {
          ctrl.view.configs.filters.items.push(id)
        })
        build()
      })
    }

    function hasTable(view) {
      if (!ctrl.question) return false
      return [
        Question.Types.CHOICE,
        Question.Types.RANK,
        Question.Types.SCALE,
        Question.Types.NPS,
        Question.Types.MOOD,
        Question.Types.RATING,
        Question.Types.MATRIX,
        Question.Types.NUMERIC, // TOOD: verify
        Question.Types.HIDDEN_VARIABLES, // TODO: verify
        Question.Types.CONSTANT_SUM, // TODO: support
        Question.Types.SCORE, // TODO: support
      ].includes(ctrl.question.type)
    }

    function hasChart(view) {
      if (!ctrl.question) return false
      return CHART_QUESTION_TYPES.includes(ctrl.question.type)
    }

    function hasList(view) {
      if (!ctrl.question) return false
      return [
        Question.Types.SINGLE_TEXT,
        Question.Types.TEXT,
        Question.Types.SCAN,
        Question.Types.FOLLOW_UP, // TODO: verify
      ].includes(ctrl.question.type)
    }

    function hasCloud(view) {
      if (!ctrl.question) return false
      return [
        Question.Types.SINGLE_TEXT,
        Question.Types.TEXT,
        Question.Types.SCAN,
      ].includes(ctrl.question.type)
    }

    function hasImages(view) {
      if (!ctrl.question) return false
      return [Question.Types.IMAGE].includes(ctrl.question.type)
    }

    function hasMap(view) {
      if (!ctrl.question) return false
      return [Question.Types.LOCATION].includes(ctrl.question.type)
      // DEPRECATED: Question.Types.PLACES_NEAR_ME
    }

    function hasChoiceCapture(view) {
      if (!ctrl.question) return false
      return !!ctrl.question.choices.find(choice => choice.isCapture)
    }

    function buildChoiceCapture() {
      var view = ctrl.view
      var datapack = ctrl.datapack
      var dashboard = ctrl.dashboard
      var prefilters = getAllPrefilters()
      var query = ctrl.view.choiceCapture.query.toLowerCase()

      // apply prefilters
      var csv = ctrl.csv.filter(function(row) {
        return _.every(prefilters, function(filter) {
          return filter.match(row)
        })
      })

      // apply completesOnly filter if enabled
      if (dashboard.completesOnly) {
        csv = csv.filter(function(row) {
          return ctrl.completesOnlyFilter.match(row)
        })
      }

      var choiceCapture = {
        items: [],
      }
      for (const choice of ctrl.question.choices) {
        if (!choice.isCapture) continue
        const questionId = view.questionId
        const loop = view.slots.loop || '-'
        function check(key, source) {
          const idx = datapack.mappings.columns[key]
          if (idx === undefined) return
          const items = csv
            .filter(function(row) {
              var value = row[idx]
              return value && value.toLowerCase().includes(query)
            })
            .map(function(row) {
              return { source: source, text: row[idx] }
            })
          choiceCapture.items.push(...items)
        }
        for (const statement of ctrl.question.statements) {
          const key = `q_${questionId}_l_${loop}_s_${statement.id}_c_${choice.id}_capture`
          check(key, `${statement.label} > ${choice.label}`)
        }
        const key = `q_${questionId}_l_${loop}_c_${choice.id}_capture`
        check(key, choice.label)
      }
      choiceCapture.count = choiceCapture.items.length
      ctrl.choiceCapture = choiceCapture
    }

    function queryChoiceCapture(query) {
      ctrl.view.choiceCapture.query = query
      $scope.$applyAsync(function() {
        buildChoiceCapture()
      })
    }

    function buildList() {
      var view = ctrl.view
      var query = ctrl.view.list.query.toLowerCase()
      var datapack = ctrl.datapack
      var dashboard = ctrl.dashboard
      var prefilters = getAllPrefilters()
      var csv = ctrl.csv.filter(function(row) {
        return _.every(prefilters, function(filter) {
          return filter.match(row)
        })
      })
      // the completesOnly setting (default) can be switched off to include exits & overquotas too
      if (dashboard.completesOnly) {
        csv = csv.filter(function(row) {
          return ctrl.completesOnlyFilter.match(row)
        })
      }
      var questionId = view.questionId
      var loop = view.slots.loop || '-'
      var textKey = `q_${questionId}_l_${loop}_text`
      var textIdx = datapack.mappings.columns[textKey]
      var idIdx = datapack.mappings.columns.id
      var labels =
        ctrl.question && _.isArray(ctrl.question.textFieldLabels)
          ? ctrl.question.textFieldLabels
          : []
      var labelsEnabled = labels.length > 0
      ctrl.list = {}
      ctrl.list.items = csv
        .filter(function(row) {
          var value = row[textIdx]
          return value && value.toLowerCase().includes(query)
        })
        .map(function(row) {
          var text = _.isString(row[textIdx]) ? row[textIdx] : ''
          // text (answer-only) feeds the word cloud, so labels must NOT be baked in
          var sanitized = text.replace(/\|/g, ' | ')
          // display pairs each field value with its label for the list + export
          var display = sanitized
          if (labelsEnabled) {
            display = text
              .split('|')
              .map(function(value, i) {
                return labels[i] ? labels[i] + ': ' + value : value
              })
              .join(' | ')
          }
          return {
            id: row[idIdx],
            text: sanitized,
            display: display,
          }
        })
      ctrl.list.count = ctrl.list.items.length
    }

    function queryList(query) {
      ctrl.view.list.query = query
      $scope.$applyAsync(function() {
        buildList()
        buildCloud()
      })
    }

    function buildImages() {
      console.log('buildImages')
      var view = ctrl.view
      var datapack = ctrl.datapack
      var prefilters = getAllPrefilters()
      var csv = ctrl.csv.filter(function(row) {
        return _.every(prefilters, function(filter) {
          return filter.match(row)
        })
      })
      var questionId = view.questionId
      var loop = view.slots.loop || '-'
      var textKey = `q_${questionId}_l_${loop}_text`
      var textIdx = datapack.mappings.columns[textKey]
      var idIdx = datapack.mappings.columns.id
      ctrl.images = {}
      ctrl.images.items = csv
        .filter(function(row) {
          var value = row[textIdx]
          return value
        })
        .map(function(row) {
          return {
            id: row[idIdx],
            url: row[textIdx],
          }
        })
      ctrl.images.count = ctrl.images.items.length
    }

    function buildMap() {
      var view = ctrl.view
      var datapack = ctrl.datapack
      var dashboard = ctrl.dashboard
      var prefilters = getAllPrefilters()
      var csv = ctrl.csv.filter(function(row) {
        return _.every(prefilters, function(filter) {
          return filter.match(row)
        })
      })
      // the completesOnly setting (default) can be switched off to include exits & overquotas too
      if (dashboard.completesOnly) {
        csv = csv.filter(function(row) {
          return ctrl.completesOnlyFilter.match(row)
        })
      }
      var questionId = view.questionId
      var loop = view.slots.loop || '-'
      var textKey = `q_${questionId}_l_${loop}_text`
      var textIdx = datapack.mappings.columns[textKey]
      var idIdx = datapack.mappings.columns.id
      var textAnswers = csv
        .filter(function(row) {
          var value = row[textIdx]
          return value
        })
        .map(function(row) {
          return {
            responseId: row[idIdx],
            textAnswer: row[textIdx],
          }
        })
      ctrl.map = {}
      ctrl.map.locationSet = new LocationSet().fromTextAnswers(textAnswers)
      ctrl.map.count = textAnswers.length
    }

    function showThemeDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-theme-dialog__dialog">',
          '<survey-explorer-theme-dialog ',
            'subscriber="subscriber"',
            'dashboard="dashboard"',
            'view="view"',
            'on-done="dialog.close()" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          subscriber: ctrl.subscriber,
          dashboard: ctrl.dashboard,
          view: ctrl.view,
        },
      }
      return glDialog.show(options)
    }

    function editTheme() {
      showThemeDialog().finally(function() {
        // apply subscriber theme to profile theme because theme will be
        // resolved from the profile not subscriber
        ctrl.profile.themeContext.deserialize(
          ctrl.subscriber.themeContext.serialize()
        )
        // TODO: support cancel
        build()
      })
    }

    function exportAs(type, questionsMode) {
      if (type === 'workbook') {
        return showExportViewsDialog(type)
          .then(exportDashboardWorkbook)
          .catch(angular.noop)
      }
      if (type === 'pptx') {
        return showExportViewsDialog(type)
          .then(exportDashboardPPTX)
          .catch(angular.noop)
      }
      var survey = ctrl.datapack.survey
      var responseType = ctrl.dashboard.completesOnly ? 'COMPLETE' : null // ctrl.getSelectedResponseType()
      if (!survey.questions) {
        survey.questions = survey.views
          .filter(function(view) {
            return view.type === 'QUESTION'
          })
          .map(function(view) {
            return view.value
          })
      }
      if (['qcsv', 'qxlsx', 'qspss'].includes(type)) {
        // this export is temporary and should not be available
        // with the new analysis since it focuses on outputting the visualisations
        ctrl.expandedExporter = null
        var questionIds = []
        // hidden is always allowed for 'ALL_INCLUDING_HIDDEN' and 'DASHBOARD_VISIBLE' modes
        var allowHidden = questionsMode !== 'EDITOR_VISIBLE'
        if (questionsMode === 'DASHBOARD_VISIBLE') {
          questionIds = ctrl.dashboard.views
            .filter(function(view) {
              return view.type === 'question'
            })
            .map(function(view) {
              return view.questionId
            })
        }
        var options = {
          surveyId: survey.id,
          responseType: responseType,
          shareToken: null, // ctrl.options.shareToken,
          questionIds: questionIds,
          labelsToRewrite: {}, // survey.labelsToRewrite,
          onlyLoopVariableIds: null, // ctrl.options.onlyLoopVariableIds,
          filterSets: null, // ctrl.filterSetGroup.getSelected(),
          filterSetsOperator: null, // ctrl.filterSetGroup.getOperator(),
          weights: ctrl.dashboard.weightScheme.getWeightsForExport(),
          allowHidden: allowHidden,
        }
        if (type === 'qxlsx') {
          options.exportFormat = 'xlsx'
        }
        if (type === 'qspss') {
          options.exportFormat = 'spss'
        }
        // IMPORTANT: SPSS doesn't support durations so we should always set it to false
        options.withDuration =
          options.exportFormat !== 'spss' &&
          ctrl.isSSR &&
          ctrl.subscriber.data.withDurationExport
        surveyReport.createExport(options)
      }
      if (type === 'xlsx') {
        reportQuestionExporter.exportDashboardWorkbook(
          survey,
          null, // ctrl.filterSetGroup.getSelected(),
          null, // ctrl.filterSetGroup.getOperator(),
          responseType
        )
      }
      if (type === 'pptx') {
        reportPPTXExporter.export(survey)
      }
    }

    function isResponsesExporter(format) {
      return ['qcsv', 'qxlsx', 'qspss'].indexOf(format.type) !== -1
    }

    function isSimpleExporter(format) {
      return !isResponsesExporter(format)
    }

    function toggleExporterSubmenu($event, type) {
      $event.preventDefault()
      $event.stopPropagation()
      ctrl.expandedExporter = ctrl.expandedExporter === type ? null : type
    }

    function onExportMenuClose() {
      ctrl.expandedExporter = null
    }

    // TODO: there are others
    var linearChoiceQuestionTypes = [
      Question.Types.MATRIX,
      Question.Types.SCALE,
    ]
    function hasLinearChoiceColors(questionId) {
      var question = questionsById[questionId]
      if (linearChoiceQuestionTypes.includes(question.type)) {
        return true
      }
    }

    function getStandardColor(num, reverse) {
      console.log('getStandardColor', num, reverse)
      var set = reverse
        ? ctrl.theme.standard.slice().reverse()
        : ctrl.theme.standard
      return set[num % set.length]
    }

    function getLinearColor(num, steps, reverse) {
      var set = reverse
        ? ctrl.theme.linear.slice().reverse()
        : ctrl.theme.linear
      set = colors.getGradient(set, steps)
      return set[num % set.length]
    }

    function setChartType(value) {
      ctrl.view.chart.type = value
      buildChart()
    }

    function isChartRotatable(type) {
      return [ChartTypes.STACKED_BAR, ChartTypes.GROUPED_BAR].includes(type)
    }

    function toggleChartRotate(value) {
      value = _.isBoolean(value) ? value : !ctrl.view.chart.rotate
      ctrl.view.chart.rotate = value
      buildChart()
    }

    function toggleChartAbsolute(value) {
      value = _.isBoolean(value) ? value : !ctrl.view.chart.absolute
      ctrl.view.chart.absolute = value
      buildChart()
    }

    function toggleTableAbsolute(value) {
      value = _.isBoolean(value) ? value : !ctrl.view.table.absolute
      ctrl.view.table.absolute = value
      buildTable()
    }

    function showModsDialog(config, options, isChoices) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-mods-dialog__dialog">',
          '<survey-explorer-mods-dialog ',
            'config="config"',
            'options="options"',
            'is-choices="isChoices"',
            'on-done="dialog.close($config)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          config: config,
          options: options,
          isChoices: isChoices,
        },
      }
      return glDialog.show(options)
    }

    function showSettingsDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-settings-dialog__dialog">',
          '<survey-explorer-settings-dialog ',
            'dashboard="dashboard"',
            'on-apply="dialog.close($remove)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var dashboard = ctrl.dashboard.clone()
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          dashboard: dashboard,
        },
      }
      return glDialog.show(options).then(function(remove) {
        if (remove) {
          destroyDashboard()
        } else {
          // console.log(ctrl.dashboard.serialize())
          ctrl.dashboard.copy(dashboard)
          syncDashboard(ctrl.dashboard)
          // console.log(ctrl.dashboard.serialize())

          // refresh current view
          const view = ctrl.dashboard.views.find(function(v) {
            return v.id === ctrl.view.id
          })
          setView(null, view)
        }
      })
    }

    function editSettings() {
      showSettingsDialog()
    }

    function showWeightSchemeDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-weighting-dialog__dialog">',
          '<survey-explorer-weighting-dialog ',
            'dashboard="dashboard"',
            'is-shared="isShared"',
            'on-apply="dialog.close()" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          dashboard: ctrl.dashboard,
          isShared: ctrl.isShared,
        },
      }
      return glDialog.show(options).then(function() {
        applyWeightScheme()
        build()
      })
    }

    function editWeightScheme() {
      showWeightSchemeDialog()
    }

    function switchToV1() {
      $rootScope.$emit('toggleLegacy', true)
    }

    function copyShareLink() {
      const url = configService.getSubscriberPortalUrl(
        '/dashboards/' + ctrl.dashboard.id
      )
      clipboardService.copy(url)
    }

    function save() {
      if (ctrl.dashboard.saving) return
      updateRestricted()
      var oldId = ctrl.dashboard.isNew ? ctrl.dashboard.id : null
      subscriberService.saveSubscriber(ctrl.subscriber).then(function() {
        datapackService.saveDashboard(ctrl.dashboard).then(function() {
          syncDashboard(ctrl.dashboard, oldId)
          watchUnsaved(true)
        })
      })
    }

    function isExportableView(view) {
      if (!view || view.type !== 'question') return false
      return !(ctrl.isShared && view.private)
    }

    function isChartCompatible(view) {
      var question = questionsById[view.questionId]
      return !!question && CHART_QUESTION_TYPES.includes(question.type)
    }

    function showExportViewsDialog(format) {
      var viewsByMode = {
        all: ctrl.dashboard.views.filter(isExportableView),
        current: [ctrl.view].filter(isExportableView),
        selected: getCurrentAndSelectedViews().filter(isExportableView),
      }

      // Nothing on the dashboard is exportable -- skip the dialog entirely.
      if (!viewsByMode.all.length) {
        return $q.reject()
      }

      function buildFacts(views) {
        return {
          count: views.length,
          compatible: views.some(isChartCompatible),
        }
      }

      var modes = {
        all: buildFacts(viewsByMode.all),
        current: buildFacts(viewsByMode.current),
        selected: buildFacts(viewsByMode.selected),
      }
      modes.current.label = ctrl.view ? ctrl.view.label : ''

      // prettier-ignore
      var template = [
        '<gl-dialog class="survey-explorer-export-views-dialog__dialog">',
          '<survey-explorer-export-views-dialog ',
            'format="{{format}}"',
            'modes="modes"',
            'on-export="dialog.close($mode)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          format: format,
          modes: modes,
        },
      }
      return glDialog.show(options).then(function(mode) {
        return viewsByMode[mode]
      })
    }

    function exportDashboardWorkbook(views) {
      var currentView = ctrl.view
      // convert views to sheets
      var sheets = []
      for (var view of views) {
        setView(null, view, true)
        addWorkbookSheetFromCurrentView(sheets)
      }
      setView(null, currentView, true)
      surveyExplorerXLSXService.generate(sheets).then(function(resp) {
        const blob = new Blob([resp], { type: 'application/octet-stream' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = 'workbook.xlsx'
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(url)
      })
    }

    function addWorkbookSheetFromCurrentView(sheets) {
      var view = ctrl.view
      var sheet = {
        name: '' + (sheets.length + 1), // view.label
        rows: [],
      }
      // list
      if (hasList(ctrl.view)) {
        sheet.rows.push(['Prefilters', getPrefilterNames().join(', ') || '-']) // prettier-ignore
        sheet.rows.push([view.label])
        for (var item of ctrl.list.items) {
          sheet.rows.push([item.display])
        }
        sheets.push(sheet)
      }
      // map
      if (hasMap(ctrl.view)) {
        sheet.rows.push(['Prefilters', getPrefilterNames().join(', ') || '-']) // prettier-ignore
        sheet.rows.push([view.label])
        sheet.rows.push([
          'Country',
          'State',
          'City',
          'Suburb',
          'Postcode',
          'LatLng',
          'Name',
        ])
        for (var item of ctrl.map.locationSet.locations) {
          sheet.rows.push([
            item.country,
            item.state,
            item.city,
            item.suburb,
            item.postcode,
            item.latlng,
            item.name,
          ])
        }
        sheets.push(sheet)
      }
      // table
      if (hasTable(ctrl.view)) {
        sheet.rows.push(['Prefilters', getPrefilterNames().join(', ') || '-']) // prettier-ignore
        if (ctrl.view.slots.loop) {
          sheet.rows.push(['Loop', getSlotLabel('loop', ctrl.view.slots.loop)]) // prettier-ignore
        }
        // Serialize the variable-centric slots exactly as the toolbar shows them
        // (e.g. Statements -> Rows, Choices -> Columns, Filters -> -).
        ctrl.slotModel.categories.forEach(function(category) {
          sheet.rows.push([_.capitalize(category), getSlotValueLabel(category)]) // prettier-ignore
        })
        sheet.rows.push(['Values', getSlotLabel('format', ctrl.view.slots.format)]) // prettier-ignore
        sheet.rows.push(...getTableExportRows())
        sheets.push(sheet)
      }
      // choice capture
      if (hasChoiceCapture(ctrl.view)) {
        sheet.rows.push(['Choice Capture', 'Source'])
        for (const item of ctrl.choiceCapture.items) {
          sheet.rows.push([item.text, item.source])
        }
      }
    }

    function exportDashboardPPTX(views) {
      function getValue(format, cell) {
        if (format === 'count') {
          return cell.count
        }
        if (format === 'sum') {
          return cell.sum
        }
        if (format === 'average') {
          return cell.average
        }
        if (format === 'average-incl') {
          return cell.averageIncl
        }
        if (format === 'sum-percent') {
          return (cell.sumPercent || 0) * 100
        }
        if (format === 'cell-percent') {
          return (cell.cellPercent || 0) * 100
        }
        if (format === 'row-percent') {
          return cell.rowPercent * 100
        }
        if (format === 'col-percent') {
          return cell.colPercent * 100
        }
        if (format === 'total-percent') {
          return cell.totalPercent * 100
        }
      }
      function getFormatCode(dp, absolute) {
        // Create format string with correct number of decimal places
        // e.g., for 2 decimal places: "0.00"
        const format = dp === 0 ? '0' : `0.${'0'.repeat(dp)}`
        // e.g., if absolute, return "0.00" if not, return   "0.00\"%\""
        return absolute ? format : `${format}"%"`
      }
      var dp = ctrl.dashboard.decimalPlaces
      var currentView = ctrl.view
      var ppt = {
        slides: [],
      }
      for (var view of views) {
        setView(null, view, true)
        var data = ctrl.data
        var slide = {
          data: [],
          config: {
            title: ctrl.view.label,
            showTitle: true,
            chartColors: [],
          },
          footer: '',
        }
        if (hasChart(view)) {
          var format = ctrl.view.slots.format
          var type = ctrl.view.chart.type
          var absolute = ['count', 'sum', 'average', 'average-incl'].includes(
            format
          )
          var dpFormat = getFormatCode(dp, absolute)
          var rotate = isChartRotatable(type) ? ctrl.view.chart.rotate : false
          if (!absolute) {
            slide.config.valAxisLabelFormatCode = '0"%"'
            // slide.config.valAxisMaxVal = 100
            // slide.config.valAxisMinVal = 0
          }

          switch (type) {
            case ChartTypes.STACKED_BAR:
            case ChartTypes.GROUPED_BAR:
              slide.config.chartType = 'bar'
              // horizontal/vertical
              slide.config.barDir = rotate ? 'bar' : 'col'
              // stack/group
              slide.config.barGrouping =
                type === ChartTypes.STACKED_BAR ? 'stacked' : 'clustered'
              break
            case ChartTypes.LINE:
            case ChartTypes.STACKED_AREA:
              slide.config.chartType =
                type === ChartTypes.LINE ? 'line' : 'area'
              slide.config.lineDataSymbol = 'circle'
              slide.config.lineDataSymbolSize = 6
              if (type === ChartTypes.STACKED_AREA) {
                slide.config.barGrouping = 'stacked'
              }
              break
            case ChartTypes.SPIDER:
              slide.config.chartType = 'radar'
              slide.config.radarStyle = 'filled'
              slide.config.chartColorsOpacity = 50
              break
            case ChartTypes.PIE:
              slide.config.chartType = 'pie'
              break
          }
          // show data labels at end of bars
          slide.config.showValue = true
          // slide.config.dataLabelPosition = null // 'outEnd'
          slide.config.valueFormatCode = dpFormat
          slide.config.dataLabelFormatCode = dpFormat
          // legend
          slide.config.showLegend = true
          slide.config.legendPos = 'b'
          // footer text
          var prefilters = ctrl
            .getAllPrefilters(ctrl.isShared)
            .map(function(filter) {
              return filter.name
            })
          if (prefilters.length) {
            slide.footer += `Prefilters: ${prefilters.join(', ')} | `
          }
          // Pinned variable, resolved through the slot model so the label and its
          // type stay consistent with the toolbar (and a stale/redacted id is
          // skipped instead of crashing the export).
          var pinnedType = getTargetTypeLabel()
          var pinnedLabel = getTargetLabel()
          if (pinnedType && pinnedLabel) {
            slide.footer += `${pinnedType}: ${pinnedLabel} | `
          }
          if (ctrl.view.slots.loop) {
            var loopId = ctrl.view.slots.loop
            var loop = ctrl.view.loops.find(function(item) {
              return item.id === loopId
            })
            slide.footer += `Loop: ${loop.label} | `
          }
          slide.footer += `Total n=${ctrl.data.count.toFixed(dp)}`

          var isPie = type === ChartTypes.PIE
          var labelSource = isPie ? data.cols : data.rows
          var datasetSource = isPie ? data.rows : data.cols

          for (var cIdx = 0; cIdx < datasetSource.items.length; cIdx++) {
            var col = datasetSource.items[cIdx]
            slide.config.chartColors.push(col.color.substring(1))
            var set = {
              name: null, // col label
              labels: [], // row labels
              values: [], // cell values for each row in this col
            }
            switch (datasetSource.type) {
              case 'filter':
                set.name = col.value.name
                break
              case 'choice':
              case 'statement':
              case 'rank':
                set.name = col.value.label
                break
            }
            for (var rIdx = 0; rIdx < labelSource.items.length; rIdx++) {
              var row = labelSource.items[rIdx]
              var cell = isPie
                ? data.matrix[cIdx][rIdx]
                : data.matrix[rIdx][cIdx]
              switch (labelSource.type) {
                case 'filter':
                  set.labels.push(row.value.name)
                  set.values.push(getValue(format, cell))
                  break
                case 'choice':
                case 'statement':
                case 'rank':
                  set.labels.push(row.value.label)
                  set.values.push(getValue(format, cell))
                  break
              }
            }
            slide.data.push(set)
          }

          // Pie charts need per-slice colors from the label source
          if (isPie) {
            slide.config.chartColors = labelSource.items.map(function(item) {
              return item.color.substring(1)
            })
          }
          ppt.slides.push(slide)
        }
      }
      setView(null, currentView, true)
      surveyExplorerPPTXService.generate(ppt).then(function(resp) {
        const blob = new Blob([resp.buffer], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' }) // prettier-ignore
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'presentation.pptx'
        a.click()
        URL.revokeObjectURL(url)
      })
    }

    function getPrefilterNames() {
      var names = []
      var excludePrivate = ctrl.isShared
      // global prefilters
      for (var filterId of ctrl.dashboard.prefilters) {
        var filter = ctrl.filtersById[filterId]
        if (excludePrivate && filter.private) continue
        names.push(filter.name)
      }
      // local prefilters
      for (var filterId of ctrl.view.prefilters) {
        var filter = ctrl.filtersById[filterId]
        if (excludePrivate && filter.private) continue
        names.push(filter.name)
      }
      return names
    }

    function getSlotLabel(type, id) {
      if (!id) id = ctrl.view.slots[type]
      if (!id) return null
      var option = ctrl.slotOptions[type].find(function(option) {
        return option.id === id
      })
      // a stale slot id (its item was deleted/redacted) has no matching option
      return option ? option.label : null
    }

    function getTargetTypeLabel() {
      // Use the pinned variable inferred from the layout, so the pill label
      // stays consistent with the slots and immune to id collisions.
      if (ctrl.slotModel.pinnedCategory === 'statements') return 'Statement'
      if (ctrl.slotModel.pinnedCategory === 'choices') return 'Choice'
      if (ctrl.slotModel.pinnedCategory === 'ranks') return 'Rank'
      return null
    }

    function getTargetLabel() {
      // Label of the single pinned item, resolved through the slot model (which
      // is redact-filtered). Returns null when nothing is pinned or the pinned
      // item is gone (redacted/deleted) — callers hide the pill/footer then.
      var category = ctrl.slotModel.pinnedCategory
      if (!category) return null
      var item = (ctrl.slotModel.items[category] || []).find(function(it) {
        return it.id === ctrl.view.slots.target
      })
      return item ? item.label : null
    }

    function getSlotValueLabel(category) {
      // Display label for what a variable slot currently shows, resolved from the
      // same option array the toolbar dropdown uses — so an export reads back
      // exactly what the UI shows (Rows / Columns / - / a pinned item label).
      var value = getSlotValue(category)
      var option = (getSlotOptions(category) || []).find(function(o) {
        return o.id === value
      })
      return option ? option.label : '-'
    }

    function getCollection(tab) {
      tab = tab || ctrl.tab
      if (tab === 'views') return ctrl.dashboard.views
      if (tab === 'filters') return ctrl.dashboard.filters
    }

    function getSelectedItems(tab) {
      return getCollection(tab).filter(function(item) {
        return item.selected
      })
    }

    function getCurrentAndSelectedViews() {
      var views = [ctrl.view]
      var selectedViews = getSelectedItems('views')
      selectedViews.forEach(view => {
        if (views.indexOf(view) === -1) {
          views.push(view)
        }
      })
      return views
    }

    function getSelectedInfo() {
      var selectedItems = getSelectedItems()
      return (
        selectedItems.length +
        ' ' +
        (selectedItems.length > 1 ? ctrl.tab : ctrl.tab.slice(0, -1)) +
        ' selected'
      )
    }

    function toggleSelectItem(event, item, index) {
      if (ctrl.isMovingItems) return
      glUtils.shiftSelect(
        event,
        index,
        ctrl.anchorIndex,
        getCollection(),
        item.selected,
        setSelected
      )
      ctrl.anchorIndex = index
    }

    function setSelected(item, selected) {
      item.selected = selected
    }

    function canMove(amount) {
      var selectedItems = getSelectedItems()
      if (!selectedItems.length) return false

      var collection = getCollection()
      if (amount < 0) {
        return _.indexOf(collection, _.head(selectedItems)) > 0
      }
      if (amount > 0) {
        return (
          _.indexOf(collection, _.last(selectedItems)) < collection.length - 1
        )
      }
      return false
    }

    function moveItems(amount) {
      ctrl.moveAmountQueue = ctrl.moveAmountQueue || []
      // add move amount to queue to be processed
      ctrl.moveAmountQueue.push(amount)
      // if queue is being processed, return
      if (ctrl.isMovingItems) return

      // start processing queue
      ctrl.isMovingItems = true
      processMoveQueue().then(function() {
        ctrl.isMovingItems = false
      })
      ctrl.anchorIndex = null
    }

    function processMoveQueue() {
      return $q(function(resolve) {
        if (!ctrl.moveAmountQueue.length) {
          // no more queue to process. resolve
          return resolve()
        }
        var amount = ctrl.moveAmountQueue.shift()
        // check if amount is actionable (can move up/down)
        if (!canMove(amount)) {
          // if amount is not actionable, move on to the next queue
          return processMoveQueue().then(resolve)
        }
        doMoveItems(amount)
          .then(processMoveQueue)
          .then(resolve)
      })
    }

    function doMoveItems(amount) {
      return $q(function(resolve) {
        var collection = getCollection()
        var selected = getSelectedItems()
        var itemIndexes = selected.map(function(item) {
          return collection.indexOf(item)
        })
        var options = {
          itemClassPrefix: ctrl.itemClassPrefix,
          itemIndexes: itemIndexes,
          amount: amount,
          itemsGapSize: 12, // each item margin size
        }
        glUtils.bulkAnimateMove(options).then(function() {
          glUtils.bulkMove(collection, selected, amount, 'id')
          // set timeout to give the template some time to adjust
          // with the new index positions after move
          $timeout(function() {
            scrollSidebarToTarget(
              ctrl.tab,
              collection.indexOf(_.head(selected))
            )
            resolve()
          }, 100)
        })
      })
    }

    function canDuplicateItems() {
      var selectedItems = getSelectedItems()
      if (!selectedItems.length || ctrl.isMovingItems) return false
      if (ctrl.tab === 'filters') {
        return !ctrl.isShared || !_.every(selectedItems, { restricted: true })
      }
      return true
    }

    function duplicateItems() {
      var selectedItems = getSelectedItems()
      if (ctrl.tab === 'views') {
        duplicateViews(selectedItems)
      }
      if (ctrl.tab === 'filters') {
        duplicateFilters(selectedItems)
      }
      ctrl.anchorIndex = null
    }

    function canEditItems() {
      var selectedItems = getSelectedItems()
      if (ctrl.tab !== 'filters' || !selectedItems.length) return false
      return !ctrl.isShared || !_.every(selectedItems, { restricted: true })
    }

    function editItems() {
      var selectedItems = getSelectedItems()
      if (ctrl.tab === 'filters') {
        editFilters(null, selectedItems)
      }
    }

    function isTogglePrivate() {
      var selectedItems = getSelectedItems()
      return !_.every(selectedItems, { private: true })
    }

    function togglePrivateItems() {
      var selectedItems = getSelectedItems()
      var isPrivate = isTogglePrivate()
      if (ctrl.tab === 'views') {
        togglePrivateViews(selectedItems, isPrivate)
      }
      if (ctrl.tab === 'filters') {
        togglePrivateFilters(selectedItems, isPrivate)
      }
    }

    function showRelocateDialog(direction) {
      var options = {
        direction: direction,
        collection: getCollection(),
        selectedItems: getSelectedItems(),
        getLabel: function(item) {
          return ctrl.tab === 'views' ? item.label : item.name
        },
      }
      return relocateDialogService.show(options).then(function(amount) {
        if (_.isNumber(amount)) {
          moveItems(amount)
        }
      })
    }

    function removeItems() {
      var selectedItems = getSelectedItems()
      if (ctrl.tab === 'views') {
        removeViews(selectedItems)
      }
      if (ctrl.tab === 'filters') {
        deleteFilters(selectedItems)
      }
      ctrl.anchorIndex = null
    }

    function clearSelection() {
      getSelectedItems().forEach(function(item) {
        setSelected(item, false)
      })
      ctrl.anchorIndex = null
    }

    function onDestroy() {
      if (beaconHiddenForMobile) {
        helpService.show()
        beaconHiddenForMobile = false
      }
      $window.removeEventListener('resize', handleViewportResize)
      $document.unbind('keydown', onKeyDown)
      watchUnsaved(false)
    }
  }
})()
